<template>
	<div>
	<div id="signup" class="sign-up-warp" style="padding-left: 30px; box-sizing: border-box">
		<div class="titleContainer">
			<div class="shu"></div>
            <!-- {{isSpecial?'发布岗位':'报名参会'}} -->
			<div class="title">报名参会</div>
		</div>
        <!-- v-if="!isSpecial" -->
		<div style="background:#064CAC;height:120px"
			:class="['new-head-bar', meetData.meetId == 2018 ? 'new-head-bar1' : 'new-head-bar2']" >
			<div class="h-title">{{isBatch?'线路报名': meetData.meeting_short_name || meetData.meeting_name}}</div>
			<div class="flex-h h1" v-if="meetData.sign_time && !pathStaus"> 
				<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/yyyy1.png" alt="" />
				<span>{{meetData.sign_time}}</span>
			</div>
			<div class="flex-h h1" style="justify-content: space-between;" v-if="isBatch">
				<!-- <img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/yyyy2.png" alt="" />
				 -->
				<!-- style="cursor: pointer;" -->

				<div style="display: flex;align-items: center;cursor: pointer;" @click="tomeetList">
					<div class="" style="font-size: 14px;color: #f6f7fb;line-height: 24px;">
						已选中 {{selectMeetList.length}} 场，总费用 {{headerSelectedMeetingDisplayTotal}} 元
					</div>
					<img src="../img/arrows.png" alt="" style="width: 15px;height: 15px;margin-left: 5px;" />
				</div>

				<!-- <img @click="goVisit" v-if="this.meetData.pdf_url"
					src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/yyyy3.png" alt="" /> -->
			</div>
			<div class="flex-h h1" v-if="meetData.meeting_address">
				<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/yyyy2.png" alt="" />
				<span class="flex1" @click="toMap" style="cursor: pointer;">{{meetData.meeting_address}}</span>
				<span @click="goVisit" style="cursor: pointer;" v-if="this.meetData.pdf_url">会议介绍 </span>
				<img @click="goVisit" style="cursor: pointer;" v-if="this.meetData.pdf_url"
					src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/yyyy3.png" alt="" />
			</div>
			<!-- <div class="left" @click="goLocation"></div>
      <div class="right" @click="openPdf"></div> -->
		</div>
		<div class="content-box">
			<div class="content-item" v-if="showJob" v-loading="loading1">
				<div class="title-1 flex-h">
					<span class="t1 flex1">{{isSpecial?'岗位列表':'发布岗位'}}</span>

					<el-button type="primary" disabled style="opacity: 0.5; cursor: not-allowed;"
						v-if="audit_status==2">新增岗位</el-button>
					<el-button type="primary" disabled style="opacity: 0.5;cursor: not-allowed;"
						v-else-if="audit_status==3">新增岗位</el-button>

					<el-button type="primary" v-else @click="goUp">新增岗位</el-button>

					<el-button type="primary" v-if="audit_status!=2&&audit_status!=3" @click="openPublishedJobDialog">选择已发布岗位</el-button>
					<el-button type="primary" disabled style="opacity: 0.5;cursor: not-allowed;" v-else>选择已发布岗位</el-button>
					<!-- <span class="t2-btn" @click="goUp">新增岗位</span> -->
				</div>
				<div class="item-wrap" v-if="companyJobList.length > 0">
					<div class="item-job-box">
						<div v-for="(item, index) in companyJobList" :key="index">
							<div class="item flex-h" v-if="index < jobNum">
								<div class="left flex1" @click="goJobDetail(item.id)">
									<div class="flex-h t1-box">
										<span class="t1">{{ item.job_name }}</span>
										<img v-if="index < 3" class="img2"
											src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/jian3.png"
											mode="" />
										<span class="flex1"></span>
										<span class="t4">{{ item.salary || '面议' }}</span>
									</div>

									<div class="t2-box flex-h">
										<div v-if="item.work_city && item.work_county">
											<span class="t2">{{ item.work_city | replaceTitlte }} ·
												{{ item.work_county | replaceTitlte }}</span><span class="t3"></span>
										</div>
										<span
											class="t2">{{ item.education === '不限' || !item.education ? '学历不限' : item.education }}</span>
										<span class="t3"></span><span
											class="t2">{{ item.job_type === 2 ? '实习' : item.job_type === 3 ? '兼职' : '全职' }}</span>
										<span class="flex1"></span>
										<span class="t5">招聘人数：{{ item.job_num || 1 }}</span>
									</div>

								</div>

								<div class="" style="display: flex;align-items: center;">



									<!-- <el-button type="danger" size="small" @click="deleteJob(index)"
										v-if="">删除</el-button>
										
									<el-button type="danger" size="small" disabled v-else>删除</el-button> -->
									<div class=""
										style="color: #FFF;background-color: #F56C6C;border-color: #F56C6C;width: 60px;height: 32px;text-align: center;line-height: 32px;font-size: 14px;border-radius: 4px;cursor: pointer;"
										:style="(audit_status==0||audit_status==1||audit_status==5)&&companyJobList.length!=1?'':'opacity: 0.5;cursor: no-drop;'"
										@click="deleteJob(index)">
										删除
									</div>

								</div>


							</div>
						</div>
						<div class="item-job-more" @click="seeMoreJob" v-if="companyJobList.length > 3">
							{{ jobNum === 100 ? '收起' : '查看全部职位' }}
						</div>
					</div>
				</div>
				<div class="" v-else>
					<img style="display:block" class="empty_noinfo-box"
						src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/21/nqevdld0cacuxzox.png"
						mode="" />
					<div class="empty_noinfo-txt">请先发布岗位</div>
				</div>
			</div>
			<div class="content-item" v-if="headIndex === 1 && meetData.meetId == 2018">
				<div class="title-1 flex-h">
					<span class="t1 flex1">申请展位数</span>
				</div>

				<div class="title-3 flex-h">
					<input @blur="isAdv = false" :focus="isAdv" type="number" class="t1 flex1" v-model="boothNum"
						placeholder="请输入您要申请的展位数" />
					<div class="v-img" @click="isAdv = true">
						<image src="../../static/newicon/editnew.png" mode=""></image>
					</div>
				</div>
			</div>
			<div class="content-item" v-if="headIndex === 1&&needStaffInfo&&!isSpecial" style="padding-bottom: 0;">
				<div class="title-1 flex-h">
					<span class="t1 flex1">拟参会人员信息</span>
				</div>
				<div v-for="(item, index) in staffList" :key="index">
					<div class="title-2 flex-h" v-if="staffList.length > 1">
						<span class="flex1"
							style="font-weight: 500">参会人员{{ staffList.length > 1 ? index + 1 : '' }}</span>
						<div class="right" @click="deleteStaff(index, item)" v-if="audit_status==0||audit_status==1"
							style="cursor: pointer;">
							<img style="width: 20px; height: 20px;"
								src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/l39m30f9jhz76vtj.png"
								mode="" />
						</div>
					</div>
					<div class="title-5">
						<div class="title-item flex-h title-item-border">
							<span class="left" style="font-weight: 500">姓名</span>
							<input v-model="item.name" class="flex1" type="span" maxlength="10"
								placeholder="请输入来校招聘人员的姓名" />
							<!-- <image src="../../static/newicon/editnew.png" mode=""></image> -->
						</div>
						<div class="title-item flex-h title-item-border" style="cursor: pointer">
							<span class="left" style="font-weight: 500; margin-right: 20px">性别</span>
							<img @click="selectsex('男', item)"
								:src="item.sex === '男' ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/sure.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/icon_nor.png'"
								mode="" />
							<span @click="selectsex('男', item)" style="width: 100px; padding-left: 10px">男</span>
							<img @click="selectsex('女', item)"
								:src="item.sex === '女' ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/sure.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/icon_nor.png'"
								mode="" />
							<span @click="selectsex('女', item)" style="width: 100px; padding-left: 10px">女</span>
							<span class="flex1"></span>
						</div>
						<div class="title-item flex-h title-item-border">
							<span class="left" style="font-weight: 500">职务</span>
							<input v-model="item.postion" class="flex1" maxlength="10" type="span"
								placeholder="请输入来校招聘人员的职位" />
							<!-- <image src="../../static/newicon/editnew.png" mode=""></image> -->
						</div>
						<div class="title-item flex-h">
							<span class="left" style="font-weight: 500">电话</span>
							<input v-model="item.tel" class="flex1" maxlength="11" type="span"
								placeholder="请输入来校招聘人员的电话" />
							<!-- <image src="../../static/newicon/editnew.png" mode=""></image> -->
						</div>
					</div>
				</div>
				<div class="title-4 flex-h" @click="addStaff" style="border-bottom: none;cursor: pointer;"
					v-if="audit_status==0||audit_status==1">
					<span class="flex1"></span>
					<span class="right">新增来校招聘人员</span>
					<img style="width: 24px; height: 24px;margin-right:20px;margin-left:10px"
						src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/cr2.png" mode="" />
				</div>
				<div class="title-4 flex-h" style="border-bottom: none;cursor: not-allowed;" v-else>
					<span class="flex1"></span>
					<span class="right">新增来校招聘人员</span>
					<img style="width: 24px; height: 24px;margin-right:20px;margin-left:10px"
						src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/10/10/cr2.png" mode="" />
				</div>
			</div>
			<!-- <div class="" style="height: 300px"></div> -->
		</div>
		<!-- <div class="foot-btn-box">
      <div class="foot-btn" @click="sureSign">立即报名</div>
    </div> -->

		<div class="foot-btn-wrap" v-if="!isSpecial">
			<el-button type="primary" @click="cancleSign" v-if="audit_status==1||(isOnlineMeeting&&isComplete)">取消报名</el-button>
			<el-button type="primary" @click="sureSign(0)" v-if="audit_status==1||audit_status==5||(isOnlineMeeting&&isComplete)">修改报名</el-button>
			<el-button type="primary" disabled style="opacity: 0.5;cursor: not-allowed;"
				v-if="!(isOnlineMeeting&&isComplete)&&(audit_status==3||audit_status==2)">立即报名</el-button>
			<el-button type="primary" @click="sureSign(1)" v-if="!(isOnlineMeeting&&isComplete)&&audit_status==0">立即报名</el-button>
		</div>

		<div class="foot-btn-wrap" v-else>
			<el-button type="primary" @click="sureSign(1)">确定</el-button>
		</div>


		<div class="previewDialogVisible">
			<el-dialog :visible.sync="previewDialogVisible" @close='dialogClose' :show-close='false'
				:close-on-click-modal="false" :close-on-press-escape="false" width="1000px" top="0"
				class="previewDialogVisible">
				<div class="previewElDialog">
					<img class="close" @click="previewCloseElDialog" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">支付方式一：微信扫码支付</div>
						<div class="qrcodeContainer">

							<div class="qrcode">
								<div class="qrcode__wechat-icon">
									<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/15/hwqylu4nxq08pfnu.png"
										alt="" />
								</div>
								<qrcode-vue class="qrcode__image" :value="code_url" :size="200" color="#000000"
									bg-color="#ffffff" />
								<!-- <div class="hite1">
									扫描<span style="color:#0084FF;">识别二维码支付</span>
								</div> -->
								<div class="hite2 qrcode__payment-tip">
									请用微信扫码支付 <span class="qrcode__amount">{{platformMeetingPrice}}元</span>
								</div>
								<div class="hite2 qrcode__warning-tip">
									<!-- <i class="el-icon-warning-outline"></i> -->
                                    <img class="el-icon-warning-outline" style="width: 18px;height: 16px;vertical-align: middle;transform: translate(-5px, 4px);" src="https://oss.sx985.com/2023/03/24/sanjiaoxing1.png" alt="" />
									<span>支付过程中请勿关闭本页面，否则支付和报名将失败。</span>
								</div>
							</div>
							<div class="offline-payment">
								<div class="offline-payment__title">支付方式二：线下对公打款</div>
								<div class="offline-payment__card">
									<div class="offline-payment__step">1. 按如下对公账号打款</div>
									<div class="offline-payment__account">
										<div><span style="width: 80px;">账户名：</span><strong>武汉升学就业在线科技股份有限公司</strong></div>
										<div><span style="width: 80px;">账户号：</span><strong>3202 0064 0920 0062 096</strong></div>
										<div><span style="width: 80px;">开户银行：</span><strong>中国工商银行股份有限公司武汉地铁支行</strong></div>
									</div>
									<div class="offline-payment__service">
										<div class="offline-payment__step">2.付款后，将付款截图和报名场次发给微信客服</div>
										<div class="offline-payment__service-qrcode"></div>
										<div>扫码联系客服</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>




		<div class="preview">
			<el-dialog :visible.sync="dialogVisible" :close-on-click-modal='false' :show-close="false"
				@close='elDialogClose2' width="500px">
				<div class="elDialog">
					<!-- <img class="close" @click="closeElDialog" src="../img/close.png" alt="" /> -->
					<div class="main">
						<!-- <div class="title">双选会预览</div> -->
						<div class="" style="font-weight: bold;font-size: 18px;text-align: center;color: #333333;">
							{{audit_status==2?'审核通过':audit_status==3?'审核未通过':meetData.meeting_price?'报名提交成功':'报名提交成功' }}
						</div>
						<div class="" style="display: flex;align-items: center;justify-content: center;margin:10px 0;">
                            
							<img style="width:60px;height: 60px;" src="../img/audit2.png" alt=""
								v-if="audit_status==2" />
							<img style="width:60px;height: 60px;" src="../img/audit3.png" alt=""
								v-else-if="audit_status==3" />
                            <img v-else style="width:60px;height: 60px;" src="../img/audit2.png" alt=""  />  
						</div>
						<div class=""
							style="font-weight: 500;font-size: 16px;color: #333333;text-align: center;margin-bottom: 20px;">
							<!-- {{audit_status==2?'恭喜您的报名审核通过':audit_status==3?'抱歉，您的报名未审核通过':'报名'+meetData.meeting_price?'缴费提交':'提交'+'成功！我们将尽快进行审核' }} -->
							<!-- {{audit_status|official}} -->
							{{official}}
						</div>
                        <div class=""
                        	style="background: #f7f8fc;border-radius: 10px;padding: 20px;box-sizing: border-box;"
                        	v-if='audit_status!=3'>
                        	<div class="" style="display: flex;align-items: center;margin-bottom: 10px;">
                        		<!-- <img src="../img/star2.png" alt=""
                        			style="width: 20px;height: 20px;margin-right: 10px;" /> -->
                        		<div class="" style="font-weight: bold;font-size: 18px;color: #333333;">
                        			温馨提示</div>
                        	</div>
                        
                        	<div class=""
                        		style="font-weight: 500;font-size: 16px;color: #000000;margin-bottom: 10px;line-height: 25px;">
                        		<strong>1、审核</strong> </br>
                        		我们将尽快审核，审核结果在【我的报名】中查看。</br>
                        	</div>
                        
                        	<div class=""
                        		style="font-weight: 500;font-size: 16px;color: #000000;margin-bottom: 10px;line-height: 25px;">
                        		<strong>2、线上会场维护</strong> </br>
                        		企业报名后，请及时返回平台首页完善企业主页、发布职位，活动期间积极登录小程序，及时回复学生消息和接收简历。</br>
                        		系统会根据HR活跃度，优先将您的岗位置顶并推荐给更多学生。
                        	</div>
                        	<div class=""
                        		style="font-weight: 500;font-size: 16px;color: #606266;margin-bottom: 10px;line-height: 25px;"
                        		v-if="meetData.meeting_price&&isinvoice">
                        		3、如需开票，<span @click="goInvoice"
                        			style="text-decoration: underline;color: blue;cursor: pointer;">请输入开票信息</span>
                        	</div>
                        
                        </div>
						<div class=""
							style="background: #f7f8fc;border-radius: 10px;padding: 20px;box-sizing: border-box;margin-bottom: 20px;">
							<div class=""
								style="display: flex;align-items: center;justify-content: center;margin-bottom: 10px;">
								<img style="width:150px;height: 150px;border: 4px solid #059E6E;border-radius: 10px;"
									:src="qrcodeImg" alt="" />
							</div>
							<div class=""
								style="font-weight: 500;font-size: 16px;color: #606266;text-align: center;margin-bottom: 10px;">
								如需帮助，欢迎扫码联系客服。
							</div>
							<!-- <div class="" style="font-weight: 500;font-size: 16px;color: #606266;text-align: center;">
								{{audit_status==2?'以便获取最新的会务服务':audit_status==3?'以便获取最新的会务服务':'以便获取审核结果和会务服务'}}
							</div> -->
						</div>

						
						<div class=""
							style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
							<el-button type="primary" @click="elDialogClose2"
								style="height: 40px;width: 420px;">确定</el-button>
						</div>

					</div>
				</div>
			</el-dialog>
		</div>


		<div class="changePassword">
			<el-dialog title="填写发票信息" :close-on-click-modal='false' :visible.sync="invoice" @close='elDialogClose1'
				width="500px">
				<div class="elDialogContainer">
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							发票类型
						</div>
						<el-select v-model="invoice_type" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							开票金额
						</div>
						<!-- 0.01|| -->
						<el-input disabled v-model="envConfig.FEE || meetData.meeting_price" disabled placeholder="请输入开票金额"></el-input>
					</div>
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							名称
						</div>
						<el-input v-model="card_title" placeholder="抬头名称（必填）">
							<img slot="suffix" class="invoice-edit-icon" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/07/cr1.png" alt="">
						</el-input>
					</div>
					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							税号
						</div>
						<el-input v-model="card_number" placeholder="纳税人识别号（必填）">
							<img slot="suffix" class="invoice-edit-icon" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/07/cr1.png" alt="">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							单位地址
						</div>
						<el-input v-model="card_address" :placeholder="invoice_type==1?'公司地址（必填）':'公司地址'">
							<img slot="suffix" class="invoice-edit-icon" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/07/cr1.png" alt="">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							电话号码
						</div>
						<el-input v-model="card_tel" :placeholder="invoice_type==1?'公司电话（必填）':'公司电话'">
							<img slot="suffix" class="invoice-edit-icon" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/07/cr1.png" alt="">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							开户银行
						</div>
						<el-input v-model="card_bank" :placeholder="invoice_type==1?'开户银行（必填）':'开户银行'">
							<img slot="suffix" class="invoice-edit-icon" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/07/cr1.png" alt="">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							银行账户
						</div>
						<el-input v-model="card_bank_num" :placeholder="invoice_type==1?'银行账户（必填）':'银行账户'">
							<img slot="suffix" class="invoice-edit-icon" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/07/cr1.png" alt="">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 20px;">
						<div class="text" style="margin-bottom: 0;">
							接收邮箱
						</div>
						<el-input v-model="card_mail" placeholder="发票接收邮箱（必填）">
							<img slot="suffix" class="invoice-edit-icon" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/07/cr1.png" alt="">
						</el-input>
					</div>

				</div>
				<div class="invoice-tip">
					<i class="el-icon-info"></i>
					<span>发票7个工作日内开具，自动推送到填写的接收邮箱中</span>
				</div>
				<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
					<el-button type="primary" @click="saveForm">保存</el-button>
				</div>
			</el-dialog>
		</div>




		<div class="meetList">
			<el-dialog :title="isMeetListViewOnly ? '确认双选会场次' : (headerPaymentSummary.isAllOfficial || isFreePlatformWithOfficial ? '确认官网缴费场次' : '确认缴费信息')" :visible.sync="meetVisible" @close='elDialogClose3' @closed='elDialogClosed3' width="600px" :class="{ 'meeting-dialog--view-only': isMeetListViewOnly }" :custom-class="isMeetListViewOnly ? 'meeting-dialog__view-only-content' : ''" class="meeting-dialog">
				<div class="meeting-dialog__content" :class="{ 'meeting-dialog__content--with-total': !isMeetListViewOnly && (showPlatformTotal || isMixedPaymentMeeting || headerPaymentSummary.isAllOfficial || isFreePlatformWithOfficial) }">
					<div class="meeting-dialog__steps" v-if="!isMeetListViewOnly && isMixedPaymentMeeting">
						<div :class="['meeting-dialog__step', { 'is-active': paymentStep === 1, 'is-complete': paymentStep === 2 }]">
							<span>1</span><div class="meeting-dialog__step-label">平台缴费场次<div class="meeting-dialog__step-success" v-if="paymentStep === 2">（缴费成功）</div></div>
						</div>
						<div class="meeting-dialog__step-line"></div>
						<div :class="['meeting-dialog__step', { 'is-active': paymentStep === 2 }]">
							<span>2</span>官网缴费场次
						</div>
					</div>
					<div class="meeting-dialog__selected" v-else>已选双选会（{{ displayedMeetList.length }}）</div>
					<div class="meeting-dialog__list">
						<div class="meeting-dialog__item" v-for="item in displayedMeetList" :key="item.id">
                            <div class="meeting-dialog__cover" v-if="item.meeting_cover_img">
                            	<img :src="item.meeting_cover_img" alt="" @error="handleCoverImageError" />
                            	
                            </div>
							<div class="meeting-dialog__cover" v-else>
								<img :src="getCoverBackgroundUrl(item.id)" alt="" @error="handleCoverImageError" />
								<div class="meeting-dialog__cover-copy" :style="{ color: getCoverTextColor(item.id) }">
									<template v-if="getSchoolNameSizeClass(item.school_name) === 'two-line'">
										<div class="meeting-dialog__cover-name--two-line"
											v-for="(nameLine, lineIndex) in getSchoolNameLines(item.school_name)" :key="lineIndex">
											{{ nameLine | replaceDot }}
										</div>
									</template>
									<div v-else :class="'meeting-dialog__cover-name--' + getSchoolNameSizeClass(item.school_name)">{{ item.school_name | replaceDot }}</div>
									<div class="meeting-dialog__cover-season">秋季双选会</div>
								</div>
							</div>
							<div class="meeting-dialog__info">
								<div class="meeting-dialog__name" :title="item.meeting_name">{{item.meeting_short_name|| item.meeting_name }}</div>
								<div class="meeting-dialog__time">{{ item.meeting_time }} {{ item.meeting_hour }}</div>
								<div class="meeting-dialog__platform-signed" v-if="!isMeetListViewOnly && officialSignupSubmitted && Number(item.meeting_status) === 5">平台报名线上已成功</div>
								<div class="meeting-dialog__fee" v-if="isMeetListViewOnly || Number(item.meeting_status) !== 5">
									<span class="meeting-dialog__fee-value">{{ isMeetListViewOnly && Number(item.meeting_status) === 5 ? '官网缴费：¥' + item.stand_position_price : (getMeetingTotal(item) === '免费' ? '免费' : '费用：' + getMeetingTotal(item)) }}</span>
									<span class="meeting-dialog__adv-num-title" v-if="shouldShowMeetingAdvNum(item)">展位数</span>
									<div style="transform: scale(0.7);  margin-left: -20px;" class="meeting-dialog__adv-num" v-if="shouldShowMeetingAdvNum(item)">
										<button type="button" @click="changeMeetingAdvNum(item, getMeetingAdvNum(item) - 1)" :disabled="getMeetingAdvNum(item) <= 1">−</button>
										<input style="font-size: 18px;font-weight: bold;" type="number" min="1" max="100" step="1" :value="getMeetingAdvNum(item)" @input="changeMeetingAdvNum(item, $event.target.value)" @change="changeMeetingAdvNum(item, $event.target.value)" @blur="changeMeetingAdvNum(item, $event.target.value)" />
										<button type="button" @click="changeMeetingAdvNum(item, getMeetingAdvNum(item) + 1)" :disabled="getMeetingAdvNum(item) >= 100">+</button>
									</div>
								</div>
								<!-- <div class="meeting-dialog__fee" v-if="(isMeetListViewOnly || Number(item.meeting_status) !== 5) && '北京大学清华大学'.indexOf(item.school_name)==-1">{{ isMeetListViewOnly && Number(item.meeting_status) === 5 ? '官网缴费：¥' + item.stand_position_price  : (getMeetingTotal(item) === '免费' ? '免费' : '费用：' + getMeetingTotal(item)) }} </div> -->
								<!-- <div class="meeting-dialog__fee" v-if="(isMeetListViewOnly || Number(item.meeting_status) !== 5) &&'北京大学清华大学'.indexOf(item.school_name)>-1">{{ isMeetListViewOnly && Number(item.meeting_status) === 5 ? '官网缴费：¥' + item.stand_position_price  : (getMeetingTotal(item) === '免费' ? '免费' : '展位费 ¥1000') }} <span  v-if=" item.school_name=='清华大学'|| item.school_name=='北京大学'">（另收取服务费800元）</span></div> -->
							</div>
							<div v-if="!isMeetListViewOnly && Number(item.meeting_status) === 5">
								<el-button class="meeting-dialog__website-pay" @click="goWebsitePayment(item)">去官网缴费</el-button>
								<!-- <button v-if="canDeleteMeet(item)" class="meeting-dialog__text-remove" @click="confirmDeleteMeet(item)" type="button">删除</button> -->
                                <div style="display: block;text-align: center;box-sizing: border-box;margin-top: 10px;font-weight: 400;color:#000000;padding-left: 12px;" v-if="item.stand_position_price">费用：¥{{item.stand_position_price}}</div> 
                                <div style="display: block;text-align: center;box-sizing: border-box;margin-top: 10px;font-weight: 400;color:#000000;padding-left: 12px;" v-else>免费</div> 
							</div>
                          
							<span v-else-if="isCompletedMeeting(item)" class="meeting-dialog__registered">{{ Number(item.meeting_status) === 5 ? '平台报名线上已成功' : '已报名' }}</span>
							<button v-else-if="canDeleteMeet(item)" class="meeting-dialog__remove" @click="confirmDeleteMeet(item)" type="button"><img style="transform: scale(0.7);" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/02/xxxsahqq.png" alt="删除" /></button>
						</div>
					</div> 
					<div class="meeting-dialog__total" v-if="!isMeetListViewOnly && showPlatformTotal"><span class="meeting-dialog__selected-count">已选{{ displayedMeetList.length }}场</span><span style="font-size: 16px;" v-if="showPlatformTotal">合计:</span><span v-if="showPlatformTotal" style="font-weight: 600;color: #ff6600;">¥{{ platformMeetingPrice }}</span></div>
					<div class="meeting-dialog__footer-selected-count" v-if="!isMeetListViewOnly && (isMixedPaymentMeeting || headerPaymentSummary.isAllOfficial || isFreePlatformWithOfficial) && !showPlatformTotal">已选{{ displayedMeetList.length }}场</div>
					<div class="meeting-dialog__official-tip" v-if="!isMeetListViewOnly && ((isMixedPaymentMeeting && paymentStep === 2) || headerPaymentSummary.isAllOfficial || isFreePlatformWithOfficial)">
						<i class="el-icon-warning-outline"></i>
						<span>请前往学校官网报名线下会场，完成缴费后，请返回本页面点击<span class="meeting-dialog__official-tip-confirm">「确定」</span></span>
					</div>
					<div class="meeting-dialog__actions" v-if="!isMeetListViewOnly">
						<el-button @click="elDialogClose3">关闭</el-button>
						<el-button style="background:#ff6600 !important ;border:1px solid #ff6600 !important" class="aaaaa" type="primary" @click="toCost">{{ paymentActionText }}</el-button>
					</div>
				</div>
			
			</el-dialog>
		</div>


	</div>
		<el-dialog title="选择已发布岗位" :visible.sync="publishedJobDialogVisible" width="760px" class="published-job-dialog">
			<el-table ref="publishedJobTable" :data="publishedJobList" v-loading="publishedJobLoading" row-key="id"
				@selection-change="handlePublishedJobSelectionChange" max-height="460">
				<el-table-column type="selection" width="55" align="center" :reserve-selection="true"
					class-name="published-job-selection-cell" label-class-name="published-job-selection-header"></el-table-column>
				<el-table-column prop="job_type" label="招聘类型" min-width="120" align="center">
					<template slot-scope="scope">{{ scope.row.job_type === 2 ? '实习' : scope.row.job_type === 3 ? '兼职' : '全职' }}</template>
				</el-table-column>
				<el-table-column prop="job_name" label="职位名称" min-width="150" align="center">
					<template slot-scope="scope">{{ scope.row.job_name || scope.row.job_title }}</template>
				</el-table-column>
				<el-table-column prop="salary" label="职位薪资" min-width="120" align="center">
					<template slot-scope="scope">{{ scope.row.salary || '面议' }}</template>
				</el-table-column>
				<el-table-column prop="education" label="学历要求" min-width="120" align="center">
					<template slot-scope="scope">{{ scope.row.education === '不限' || !scope.row.education ? '不限' : scope.row.education }}</template>
				</el-table-column>
				<el-table-column prop="job_num" label="招聘人数" min-width="110" align="center">
					<template slot-scope="scope">{{ formatJobNum(scope.row.job_num) }}</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="publishedJobDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmPublishedJobSelection">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import QrcodeVue from 'qrcode.vue'
	import {
		mapMutations,
		mapState
	} from 'vuex'
	const config = require('../../WebConfig')
	export default {
		data() {
			return {
				envConfig: config,
				meetVisible: false,
				isMeetListViewOnly: false,
				paymentStep: 1,
				platformOrderNo: '',
				hasPlatformFeeWhenDialogOpened: false,
				platformPaymentCompleted: false,
				officialSignupSubmitted: false,
				officialSignupSubmitting: false,
				officialSignupDelayTimer: null,
				hasStaffListFromApi: false,

				dialogVisible: false,
				showJob: true,
				meet_1: '',
				meet_2: '',
				meet_3: '',
				meet_4: '',
				meet_5: '',
				meet_6: '',
				meet_7: '',
				isAdv: false,
				isShow: false,
				itemList1: [{
						name: '无',
						isSelected: false,
					},
					{
						name: '1',
						isSelected: false,
					},
					{
						name: '2',
						isSelected: false,
					},
					{
						name: '3',
						isSelected: false,
					},

					{
						name: '4',
						isSelected: false,
					},
					{
						name: '5',
						isSelected: false,
					},
					{
						name: '6',
						isSelected: false,
					},
					{
						name: '7',
						isSelected: false,
					},

					{
						name: '8',
						isSelected: false,
					},
					{
						name: '9',
						isSelected: false,
					},
					{
						name: '10',
						isSelected: false,
					},
				],
				welfareList: [],
				featureList: [],
				natureList: [],
				leaderinfo: {
					txt: '',
				},
				isComplete: false,
				paidMeetingPrice: '',
				percentage: 10,
				boothNum: '',
				jobNum: 3,
				headIndex: 1,
				companyJobList: [],
				companyJobList1: [],
				publishedJobDialogVisible: false,
				publishedJobLoading: false,
				publishedJobList: [],
				selectedPublishedJobIds: [],
				staffList: [{
					name: '',
					tel: '',
					sex: '男',
					postion: '',
				}, ],
				meetData: {
					lat: '',
					lng: '',
					meetId: '',
					meeting_address: '',
					meeting_name: '',
					pdf_url: '',
					school_name: '',
					sign_up_img: '',
				},
				jobDataIds: [],
				deletId: [],
				formPage: '',
				limitBoothNum: 100,
				meetId: '',
				banner_img: '',
				sign_up_img: '',


				audit_status: 0,


				request: false,
				previewDialogVisible: false,
				paymentCloseConfirmVisible: false,
				paymentCloseConfirmAutoClosed: false,

				code_url: '',

				interval: {},


				jobs: [],

				meetstr: '',



				qrcodeImg: '',

				provinceImgList: [],

				isinvoice: true,

				invoice: false,



				options: [{
					value: 0,
					label: '数字化电子普票（电子）'
				}, {
					value: 1,
					label: '数字化电子专票（电子）'
				}],

				invoice_status: 1, //发票状态
				invoice_type: 0, //发票类型
				meeting_price: null, //发票金额
				card_title: '', //企业名称
				card_number: '', //税号
				card_address: '', //公司地址
				card_tel: '', //电话号码
				card_bank: '', //开户银行
				card_bank_num: '', //银行卡账号
				card_mail: '', //接收邮箱
				order_no: '',


				isBatch: false,


				selectMeetList: [],

				loading: false,
				timer: null,
				isSpecial: false,

				loading1: false,

				costVisible: false,


				totalMeetingPrice: 0,
                pathStaus:0
			}
		},
		watch: {
			staffList: {
				handler(value) {
					this.cacheStaffList(value)
				},
				deep: true,
			},
		},
		filters: {
			replaceDot(val){
				if(val){
					return val.replace('（','(').replace('）',')')
				}else{
					return val
				}
			},
		
			salary(val) {
				if (val) {
					return val
				} else {
					return '面议'
				}
			},

		},
		async mounted() {
           
			if (this.shouldRedirectToMeetingAfterReload()) {
				this.$router.replace({
					path: '/meeting',
				})
				return
			}
			window.addEventListener('beforeunload', this.markSignupReload)
			this.pathStaus = Number(this.$route.query.pathStaus) === 1 ? 1 : 0
			let staffList = []
			this.loading1 = true
			// this.goInvoice()
			// this.getmyJobList()
			if (sessionStorage.getItem('meetObj')) {
				this.meetData = JSON.parse(sessionStorage.getItem('meetObj'))
                if(this.meetData.meeting_price){
                    this.meetData.meeting_price = this.meetData.meeting_price*1
                }
                if(this.meetData.paid_meeting_price){
                    this.meetData.paid_meeting_price = this.meetData.paid_meeting_price*1
                    if(this.meetData.paid_meeting_price>0){
                        this.meetData.meeting_price =this.meetData.paid_meeting_price
                    }
                }
				this.isBatch = JSON.parse(sessionStorage.getItem('meetObj')).isBatch
				this.isSpecial = JSON.parse(sessionStorage.getItem('meetObj')).isSpecial
				console.log('sessionStorage.getItem', JSON.parse(sessionStorage.getItem('meetObj')))

			}

			if (this.isCorporateApplyPath) {
				this.isSpecial = true
				this.meetData.meeting_price = 0
				this.meetData.paid_meeting_price = 0
				this.selectMeetList = []
				this.totalMeetingPrice = 0
			} else if (sessionStorage.getItem('selectMeetList')) {
				let selectMeetList = JSON.parse(sessionStorage.getItem('selectMeetList'))
				let totalMeetingPrice = 0
				selectMeetList.forEach((item, index, arr) => {
					arr[index].isSelected = true
					totalMeetingPrice += Number(item.meeting_price)

				})
				this.totalMeetingPrice = totalMeetingPrice
				this.selectMeetList = selectMeetList
				if (this.isOnlineMeeting) this.isSpecial = false
				console.log('sessionStorage.getItem', JSON.parse(sessionStorage.getItem('selectMeetList')))
			}
			if (sessionStorage.getItem('staffList')) {
				staffList = JSON.parse(sessionStorage.getItem('staffList'))

			}

			if (this.$route.query.isinvoice) {
				this.isinvoice = false
			}

			console.log(this.isinvoice)

			let [companyJobList, job_data1] = await Promise.all([
				this.getComJobList(),
				this.getRegMeetingDetail1(),
			])
			let job_data = []
			console.log(job_data1)
			if (job_data1.length > 0) {

			} else {
				job_data = await this.getRegMeetingDetail()
			}

			let addMeetJob = JSON.parse(localStorage.getItem('addMeetJob'))

			if (job_data1.length > 0) {
				let c_job_data = JSON.parse(job_data1)
				if (addMeetJob) {
					c_job_data = [...c_job_data, ...addMeetJob]
				}
				// let c_job_data = JSON.parse(job_data1)
				let jobID = []
				c_job_data.forEach((item, indx, arr) => {
					jobID.push(item.job_id)
				})
				this.companyJobList = companyJobList.filter((item) => {
					return jobID.includes(item.id)
				})
			} else if (job_data.length > 0) {

				console.log(this.deletId)
			
				let deletId1 = this.deletId
				if (addMeetJob) {
					let jobID = []
					addMeetJob.forEach((item, indx, arr) => {
						jobID.push(item.job_id)
					})
					deletId1 = deletId1.filter((item) => {
						return !jobID.includes(item)
					})
				}
				console.log(deletId1)
				this.companyJobList = companyJobList.filter((item) => {
					return !deletId1.includes(item.id)
				})

			} else {
				this.companyJobList = companyJobList

			}
			console.log(staffList)
			if (!this.hasStaffListFromApi && staffList.length > 0) {
				this.staffList = staffList
			} else if (!this.hasStaffListFromApi) {
				let cachedStaffList = this.getCachedStaffList()
				if (cachedStaffList.length > 0) {
					this.staffList = cachedStaffList
				}
			}

			this.loading1 = false

			// localStorage.removeItem('addMeetJob')

			 if (this.isSpecial) {
				this.setApplyData()
			}
		},
		beforeDestroy() {
			window.removeEventListener('beforeunload', this.markSignupReload)
			clearTimeout(this.officialSignupDelayTimer)
		},
		beforeRouteLeave(to, from, next) {
			if (!this.previewDialogVisible) {
				next()
				return
			}
			this.confirmClosePaymentDialog(() => next(), () => next(false))
		},
		computed: {
			...mapState({
				nextToken: (state) => state.nextToken,
				userInfo: (state) => state.userInfo,
				schoolInfo: (state) => state.schoolData,
			}),
			platformMeetList() {
				let platformMeetList = this.selectMeetList.filter((item) => Number(item.meeting_status) === 1)
				let hasPlatformFee = platformMeetList.some((item) => item.meeting_price && Number(item.meeting_price) !== 0)
				return hasPlatformFee || this.hasPlatformFeeWhenDialogOpened ? platformMeetList : []
			},
			headerPaymentSummary() {
				const platformMeetings = this.selectMeetList.filter((item) => Number(item.meeting_status) === 1)
				const officialMeetings = this.selectMeetList.filter((item) => Number(item.meeting_status) === 5)
				const platformPrice = platformMeetings.reduce((total, item) => {
					return total + (Number(item.meeting_price) || 0)
				}, 0)

				const isAllPlatform = this.selectMeetList.length > 0 && platformMeetings.length === this.selectMeetList.length
				const isAllOfficial = this.selectMeetList.length > 0 && officialMeetings.length === this.selectMeetList.length

				return {
					totalCount: this.selectMeetList.length,
					platformCount: platformMeetings.length,
					officialCount: officialMeetings.length,
					platformPrice,
					hasPaidPlatform: platformPrice > 0,
					isAllPlatform,
					isAllOfficial,
					showTotal: isAllPlatform || platformPrice > 0
				}
			},
			headerSelectedMeetingDisplayTotal() {
				return this.selectMeetList.reduce((total, item) => {
					return total + (Number(item.meeting_price) || 0) + (Number(item.stand_position_price) || 0)
				}, 0)
			},
			officialMeetList() {
				return this.selectMeetList.filter((item) => Number(item.meeting_status) === 5)
			},
			needStaffInfo() {
				if (!Array.isArray(this.selectMeetList) || this.selectMeetList.length === 0) return true
				return this.selectMeetList.some((item) => Number(item.meeting_cat) !== 2)
			},
			isOnlineMeeting() {
				return Array.isArray(this.selectMeetList) && this.selectMeetList.length > 0 && this.selectMeetList.every((item) => Number(item.meeting_cat) === 2)
			},
			isCorporateApplyPath() {
				return Number(this.$route.query.pathStaus) === 1
			},
			isFreePlatformWithOfficial() {
				let platformMeetings = this.selectMeetList.filter((item) => Number(item.meeting_status) === 1)
				return platformMeetings.length > 0 && this.officialMeetList.length > 0 && platformMeetings.every((item) => Number(item.meeting_price || 0) === 0)
			},
			paymentDialogMeetList() {
				return this.selectMeetList.filter((item) => Number(item.meeting_status) !== 1 || this.platformMeetList.length > 0)
			},
			isMixedPaymentMeeting() {
				return this.platformMeetList.length > 0 && this.officialMeetList.length > 0
			},
			displayedMeetList() {
				if (this.isMeetListViewOnly) return this.selectMeetList
				if (!this.isMixedPaymentMeeting) {
					return this.paymentDialogMeetList.filter((item) => {
						return Number(item.meeting_status) !== 1 || Number(item.meeting_price || 0) !== 0
					})
				}
				if (this.paymentStep === 1) {
					return this.platformMeetList.filter((item) => Number(item.meeting_price || 0) !== 0)
				}
				return this.officialMeetList
			},
			platformMeetingPrice() {
				let meetings = this.isMixedPaymentMeeting ? this.platformMeetList : this.paymentDialogMeetList
				return meetings.reduce((total, item) => {
					const meetingPrice = this.getFeeValue(item.meeting_price)
					return total + (this.shouldShowMeetingAdvNum(item) ? meetingPrice * this.getMeetingAdvNum(item) : meetingPrice)
				}, 0)
			},
			showPlatformTotal() {
				return this.paymentStep === 1 && Number(this.platformMeetingPrice) > 0
			},
			paymentActionText() {
				if (this.isMixedPaymentMeeting && this.paymentStep === 2) return '确定'
				if (this.platformMeetList.length === 0) return '确定'
				return Number(this.platformMeetingPrice) > 0 ? '去缴费' : '确定'
			},
			official() {
				// const meeting_price = this?.meeting_price || {};
				switch (Number(this.audit_status)) {
					case 2:
						return '恭喜您的报名审核通过'
					case 3:
						return '抱歉，您的报名未审核通过'
						break;
					default:
						let str = ''
						if (this.meetData.meeting_price) {
							// str = '报名提交成功！我们将尽快进行审核'
						} else {
							// str = '报名提交成功！我们将尽快进行审核'
						}
						return str
						break;
				}
			}
		},
		methods: {
			...mapMutations(['setIslogin']),
			getSignupReloadKey() {
				return 'signupReloadRedirect'
			},
			markSignupReload() {
				sessionStorage.setItem(this.getSignupReloadKey(), '1')
			},
			shouldRedirectToMeetingAfterReload() {
				let shouldRedirect = sessionStorage.getItem(this.getSignupReloadKey()) === '1'
				sessionStorage.removeItem(this.getSignupReloadKey())
				if (!shouldRedirect) return false
				let navigationEntries = performance.getEntriesByType ? performance.getEntriesByType('navigation') : []
				if (navigationEntries.length > 0) {
					return navigationEntries[0].type === 'reload'
				}
				return performance.navigation && performance.navigation.type === 1
			},
			getPlatformPaymentProgressKey() {
				return `signupPlatformPaymentProgress_${this.schoolInfo.admin_id}`
			},
			getSelectedMeetingIds() {
				return this.selectMeetList.map((item) => {
					let meetingKey = String(item.id)
					if (this.shouldShowMeetingAdvNum(item)) meetingKey += `:${this.getMeetingAdvNum(item)}`
					return meetingKey
				}).sort().join(',')
			},
			markCompletedPlatformMeetings() {
				this.selectMeetList.forEach((item) => {
					if (Number(item.meeting_status) === 1) {
						this.$set(item, 'isPlatformPaymentCompleted', true)
					}
				})
			},
			markCompletedOfficialMeetings(meetingList) {
				meetingList.forEach((item) => {
					if (Number(item.meeting_status) === 5) {
						this.$set(item, 'isOfficialSignupCompleted', true)
					} else if (this.isFreePlatformWithOfficial && Number(item.meeting_status) === 1 && Number(item.meeting_price || 0) === 0) {
						this.$set(item, 'isPlatformPaymentCompleted', true)
					}
				})
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.selectMeetList))
			},
			completePlatformPayment(orderNo = '') {
				this.platformOrderNo = orderNo
				this.platformPaymentCompleted = true
				this.hasPlatformFeeWhenDialogOpened = true
				this.paymentStep = 2
				this.markCompletedPlatformMeetings()
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.selectMeetList))
				sessionStorage.setItem('meetObj', JSON.stringify(this.meetData))
				sessionStorage.setItem(this.getPlatformPaymentProgressKey(), JSON.stringify({
					meetingIds: this.getSelectedMeetingIds(),
					platformOrderNo: orderNo,
				}))
				if (this.isMixedPaymentMeeting) {
					this.meetVisible = true
					this.officialSignupSubmitting = true
					clearTimeout(this.officialSignupDelayTimer)
					this.officialSignupDelayTimer = setTimeout(() => {
						this.officialSignupDelayTimer = null
						this.toSign1(orderNo, false, true, true)
					}, 1100)
					return
				}
				this.meetVisible = true
			},
			restorePlatformPaymentProgress() {
				try {
					let progress = JSON.parse(sessionStorage.getItem(this.getPlatformPaymentProgressKey()))
					let hasPlatformMeeting = this.selectMeetList.some((item) => Number(item.meeting_status) === 1)
					if (progress && progress.meetingIds === this.getSelectedMeetingIds() && hasPlatformMeeting) {
						this.platformOrderNo = progress.platformOrderNo || ''
						this.platformPaymentCompleted = true
						this.hasPlatformFeeWhenDialogOpened = true
						this.paymentStep = 2
						this.markCompletedPlatformMeetings()
						sessionStorage.setItem('selectMeetList', JSON.stringify(this.selectMeetList))
						this.meetVisible = true
					}
				} catch (error) {}
			},
			clearPlatformPaymentProgress() {
				this.paymentStep = 1
				this.platformOrderNo = ''
				this.hasPlatformFeeWhenDialogOpened = false
				this.platformPaymentCompleted = false
				sessionStorage.removeItem(this.getPlatformPaymentProgressKey())
			},
			getStaffListCacheKey() {
				return `signupStaffList_${this.schoolInfo.admin_id}`
			},
			cacheStaffList(staffList) {
				if (!Array.isArray(staffList) || !staffList.some((item) => item && (item.name || item.tel || item.postion))) return
				localStorage.setItem(this.getStaffListCacheKey(), JSON.stringify(staffList))
			},
			getCachedStaffList() {
				try {
					let staffList = JSON.parse(localStorage.getItem(this.getStaffListCacheKey()))
					return Array.isArray(staffList) ? staffList : []
				} catch (error) {
					return []
				}
			},
			getFeeValue(value) {
				const match = String(value == null ? '' : value).match(/-?\d+(?:\.\d+)?/)
				return match ? Number(match[0]) : 0
			},
			formatFee(value) {
				const amount = this.getFeeValue(value)
				return Number.isInteger(amount) ? String(amount) : amount.toFixed(2)
			},
			getMeetingTotal(item) {
				const boothFee = this.getFeeValue(item.meeting_price)
				const actualFee = this.shouldShowMeetingAdvNum(item) ? boothFee * this.getMeetingAdvNum(item) : boothFee
				return actualFee > 0 ? `¥${this.formatFee(actualFee)}` : '免费'
			},
			shouldShowMeetingAdvNum(item) {
				return !this.isMeetListViewOnly && Number(item.is_adv_display) === 1 && Number(item.meeting_status) === 1 && this.getFeeValue(item.meeting_price) > 0
			},
			getMeetingAdvNum(item) {
				const advNum = Number(item.adv_num)
				const isValidAdvNum = Number.isInteger(advNum) && advNum >= 1 && advNum <= 100
				const isModifySignup = this.isComplete && !this.isBatch
				if (Number(item.is_adv_display) !== 1 && !isModifySignup) return 1
				return isValidAdvNum ? advNum : 1
			},
			changeMeetingAdvNum(item, value) {
				let advNum = parseInt(value, 10)
				if (!Number.isFinite(advNum)) advNum = 1
				advNum = Math.max(1, Math.min(100, advNum))
				this.$set(item, 'adv_num', advNum)
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.selectMeetList))
			},
			buildPaymentRemark() {
				const selectedMeetings = this.isMixedPaymentMeeting ? this.platformMeetList : this.paymentDialogMeetList
				const details = selectedMeetings.map((meeting) => {
					const boothFee = this.getFeeValue(meeting.meeting_price)
					const actualFee = this.shouldShowMeetingAdvNum(meeting) ? boothFee * this.getMeetingAdvNum(meeting) : boothFee
					const parts = []
					if (boothFee > 0) {
						let feeText = `费用 ¥${this.formatFee(actualFee)}`
						if (this.shouldShowMeetingAdvNum(meeting)) feeText += `（购买${this.getMeetingAdvNum(meeting)}个展位）`
						parts.push(feeText)
					}
					return `${meeting.meeting_name}-${meeting.meeting_time || ''}场次-${parts.length ? parts.join('，') : '免费'}`
				})

				return `线路报名${selectedMeetings.length}场（${details.join('；')}）`
			},
			getChargedMeetCount() {
				return this.selectMeetList.filter((item) => item.meeting_price && item.meeting_price != '0').length
			},
			getCoverTemplateIndex(id) {
				const numericId = Math.abs(Number(id))
				if (!Number.isFinite(numericId) || numericId <= 0) return 1
				const fixedTemplates = { 540511: 7, 540611: 11, 540711: 54, 540811: 16  }
				if (fixedTemplates[numericId]) return fixedTemplates[numericId]
				const rawIndex = numericId % 70 || 70
				return ((rawIndex - 1) * 37 + 17) % 70 + 1
			},
			getCoverBackgroundUrl(id) {
				return `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/01/bb${this.getCoverTemplateIndex(id)}.png`
			},
			getSchoolNameSizeClass(schoolName) {
				const length = (schoolName || '').replace(/[\s（）()]/g, '').length
				if (length > 12) return 'two-line'
				if (length > 8) return 'small'
				if (length > 5) return 'medium'
				return 'large'
			},
			getSchoolNameLines(schoolName) {
				const name = schoolName || ''
				const length = name.replace(/[\s（）()]/g, '').length
				if (length <= 12) return [name]

				const firstLineLength = Math.floor((length - 2) / 2)
				let currentLength = 0
				let firstLine = ''
				let secondLine = ''
				let isSecondLine = false
				const nameParts = name.match(/（[^）]*）|\([^)]*\)|./g) || []

				nameParts.forEach((namePart) => {
					const partLength = namePart.replace(/[\s（）()]/g, '').length
					if (!isSecondLine && currentLength > 0 && currentLength + partLength > firstLineLength) {
						isSecondLine = true
					}
					if (isSecondLine) {
						secondLine += namePart
					} else {
						firstLine += namePart
					}
					if (!isSecondLine) currentLength += partLength
				})

				return [firstLine, secondLine]
			},
			getCoverTextColor(id) {
				const textColors = {
					1: '#7A4A00', 2: '#14532D', 3: '#0B3D91', 4: '#9A3412', 5: '#065F46',
					6: '#FFFFFF', 7: '#FFFFFF', 8: '#FFFFFF', 9: '#831843', 10: '#14532D',
					13: '#FFFFFF', 18: '#166534', 19: '#6D28D9', 20: '#5B3217', 21: '#7E1F4D',
					35: '#0090ff', 36: 'blue', 47: '#000000', 49: '#000000', 50: '#000000', 55: '#000000', 56: '#000000', 60: '#000000', 68: '#000000', 69: '#000000'
				}
				const templateIndex = this.getCoverTemplateIndex(id)
				if (textColors[templateIndex]) return textColors[templateIndex]
				if (templateIndex >= 31) return '#FFFFFF'
				if (templateIndex >= 11) return '#704A09'
				return '#000000'
			},
			handleCoverImageError(event) {
				event.target.style.display = 'none'
			},
		
		
			setApplyData() {
				let jobs = this.companyJobList.map((item) => {
					return {
						job_id: item.id,
						job_num: item.job_num || 1,
					}
				})
				let c_josn = {
					staffs: this.needStaffInfo ? this.staffList : [],
					adv_num: this.boothNum,
					headIndex: this.headIndex,
					deletId: this.deletId,
				}
				let obj = {
					admin_id: this.schoolInfo.admin_id,
					meeting_id: 3584,
					job_data: JSON.stringify(jobs),
					adv_num: 0,
					meeting_info_str: '',
					meeting_info: JSON.stringify(c_josn),
				}
				sessionStorage.setItem('applyData', JSON.stringify(obj))
			},
			toMap() {
				if(!this.meetData.lat){return}
				window.open(
					`https://apis.map.qq.com/uri/v1/marker?marker=coord:${this.meetData.lat},${this.meetData.lng};title:${this.meetData.meeting_address}&referer=myapp`,
					'_blank')

			},
			tomeetList() {
				this.isMeetListViewOnly = true
				this.meetVisible = true
			},
			confirmDeleteMeet(row) {
				this.$confirm(`您确定要删除${row.meeting_short_name ||row.meeting_name}吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.deleteMeet(row)
				}).catch(() => {})
			},
			canDeleteMeet(row) {
				return this.displayedMeetList.length > 1 && !this.isCompletedPlatformMeeting(row)
			},
			isCompletedPlatformMeeting(row) {
				return Number(row.meeting_status) === 1 && (this.platformPaymentCompleted || row.isPlatformPaymentCompleted)
			},
			isCompletedMeeting(row) {
				return this.isCompletedPlatformMeeting(row) || (Number(row.meeting_status) === 5 && row.isOfficialSignupCompleted)
			},
			goWebsitePayment(row) {
				if (!row.website || row.website === '暂未公布') {
					this.$message.warning('暂未公布官网缴费链接！')
					return
				}
				window.open(row.website, '_blank')
			},
			deleteMeet(row) {

				let selectMeetList = JSON.parse(JSON.stringify(this.selectMeetList))
				if (this.canDeleteMeet(row)) {
					console.log(row)
					let meetIdx = -1
					selectMeetList.forEach((item, index, arr) => {
						if (row.id == item.id) {
							meetIdx = index
						}
					})
					if (meetIdx != -1) {
						selectMeetList.splice(meetIdx, 1)

						let meetingIdList = []
						let meeting_price = 0
						let isOther = true
						selectMeetList.forEach((item, index, arr) => {
							if (item.meeting_status != 6) {
								meeting_price += Number(item.meeting_price)
								isOther = false
							}
							meetingIdList.push(item.id)
						})
						this.meetData.meetId = meetingIdList
						this.meetData.meeting_price = meeting_price
						this.meetData.isOther = isOther

					}
					console.log(selectMeetList)
					this.selectMeetList = selectMeetList

					let totalMeetingPrice = 0
					this.selectMeetList.forEach((item) => {
						totalMeetingPrice += Number(item.meeting_price)
						
					})
					this.totalMeetingPrice = totalMeetingPrice


				} else {
				}

			},
			elDialogClose3() {
				this.meetVisible = false
				if (!this.isMeetListViewOnly && !this.platformPaymentCompleted) this.clearPlatformPaymentProgress()
			},
			elDialogClosed3() {
				this.isMeetListViewOnly = false
			},

			goInvoice() {
				this.card_title = this.schoolInfo.company_name
				this.$util.post(
					`v2/school_job/getInvoiceInfoList`, {
						admin_id: this.schoolInfo.admin_id,
					},
					(res) => {
						if (res.code == 200) {
							if (res.data.length > 0) {
								console.log(res)
								this.card_number = res.data[0].tax_no
								this.card_address = res.data[0].unit_addr
								this.card_mail = res.data[0].email
								this.card_tel = res.data[0].telephone
								this.card_bank = res.data[0].deposit_bank
								this.card_bank_num = res.data[0].bank_account
							}
						}
					}
				)
				this.invoice = true
				// this.dialogVisible = false
			},
			closeElDialog() {
				this.dialogVisible = false
			},
			elDialogClose1() {
				this.invoice = false
			},
			elDialogClose2() {
				this.dialogVisible = false

				this.$router.replace({
					path: '/reglist',
				})
			},
			previewCloseElDialog() {
				this.confirmClosePaymentDialog()
			},
			confirmClosePaymentDialog(onConfirm, onCancel) {
				if (this.paymentCloseConfirmVisible) {
					if (onCancel) onCancel()
					return
				}
				this.paymentCloseConfirmAutoClosed = false
				this.paymentCloseConfirmVisible = true
				this.$confirm('支付过程中请勿关闭微信扫码支付页面，否则报名将失败。', '提示', {
					confirmButtonText: '继续支付',
					cancelButtonText: '取消支付',
					type: 'warning',
					iconClass: 'payment-close-confirm__icon',
					closeOnClickModal: false,
					closeOnPressEscape: false,
					showClose: false,
				}).then(() => {
					this.paymentCloseConfirmVisible = false
					if (onCancel) onCancel()
				}).catch(() => {
					let isAutoClosed = this.paymentCloseConfirmAutoClosed
					this.paymentCloseConfirmAutoClosed = false
					this.paymentCloseConfirmVisible = false
					if (isAutoClosed) {
						if (onCancel) onCancel()
						return
					}
					this.previewDialogVisible = false
					if (onConfirm) onConfirm()
				})
			},
			dialogClose() {
				clearInterval(this.interval)
			},
			deleteJob(index) {
				if ((this.audit_status == 0 || this.audit_status == 1 || this.audit_status == 5) && this.companyJobList
					.length != 1) {
					this.$confirm('确定要删除这个职位吗？', '提示', {
							confirmButtonspan: '确定',
							cancelButtonspan: '取消',
							type: 'warning',
						})
						.then(() => {
							this.deletId.push(this.companyJobList[index].id)
							this.companyJobList.splice(index, 1)

							if (this.isSpecial) {
								this.setApplyData()
							}


						})
						.catch(() => {
							// this.$message({
							// 	type: 'info',
							// 	message: '已取消删除',
							// })
						})
				}

			},
			goJobDetail(id) {
				sessionStorage.setItem('meetObj', JSON.stringify(this.meetData))
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.selectMeetList))
				if (this.audit_status == 0 || this.audit_status == 1) {
					this.$router.push({
						path: '/addPosition',
						query: {
							id: id,
						},
					})
				}
			},
			deleteStaff(index, item) {
				this.staffList.splice(index, 1);
			},
			cancleSign() {
				if (this.meetData.meeting_price && !this.meetData.isOther && !this.isOnlineMeeting) {
					this.$confirm('本场为收费场次，暂不支持取消，若有疑问请联系您的专属业务员！', '提示', {
							confirmButtonspan: '确定',
							showCancelButton: false,
							// cancelButtonspan: '取消',
							type: 'warning',
						})
						.then(() => {

						})
						.catch(() => {

						})
				} else {
					this.$confirm('您确定要取消报名吗?', '提示', {
							confirmButtonspan: '确定',
							cancelButtonspan: '取消',
							type: 'warning',
						})
						.then(() => {

							this.$util.post(
								`v2/school_job/cancelSchoolMeeting`, {
									admin_id: this.schoolInfo.admin_id,
									meeting_id: this.meetData.meetId || 2018,
								},
								(res) => {
									if (res.code == 200) {
										this.$message({
											message: '取消报名成功',
											type: 'success',
										})
										setTimeout(() => {
											this.$router.replace({
												path: '/reglist',
											})
										}, 1000)
									} else {
										this.$message({
											message: res.msg,
											type: 'error',
										})
									}
								}
							)
						})
						.catch(() => {

						})
				}



			},

			goVisit() {
				if (this.meetData.pdf_url) {
					window.open(this.meetData.pdf_url, '_blank')
				}
			},

			goLocation() {},
			openPdf() {},
			getComJobList() {
				return new Promise((resolve, reject) => {
					let obj = {
						admin_id: this.schoolInfo.admin_id,
						page: 1,
						size: 20,
						user_id: this.userInfo.user_id,
						st: '20250201',
						sale_status: 1
					}

					if (this.companyJobList.length === 0) {
						// this.$uniapp.loading()
					}
					this.$util.post('v2/school_job/my_job_list', obj, (res) => {
						console.log('aaaa', res)
						if (res.code === 200) {
							if (res.data.data) {
								let jobs = []
								res.data.data.forEach((item) => {
									if (item.salary_min && item.salary_max) {
										item.salary = item.salary_min + '-' + item.salary_max + 'K'
									} else if (item.salary_min > 99) {
										item.salary = item.salary_min + '-' + item.salary_max
									} else if (item.salary_min && !item.salary_max) {
										item.salary = item.salary_min + 'K+'
									} else if (!item.salary_min && item.salary_max) {
										item.salary = item.salary_max + 'K'
									} else {
										item.salary = item.salary
									}
									jobs.push(item.job_title)
								})
								localStorage.setItem('job_title', jobs)
								localStorage.setItem('job_list', JSON.stringify(res.data.data) )

								// let deletIds = localStorage.getItem('deleteId') || []
								// this.companyJobList1 = res.data.data
								// .filter((item) => {
								// 	return deletIds.indexOf(item.id) === -1
								// })
								this.totalPage = res.data.meta.last_page
								this.currentPage = 1
								localStorage.setItem('job_users', 2)
								// uni.hideTabBarRedDot({
								//     index: 1
								// })
								resolve(res.data.data)
							} else {
								// uni.showTabBarRedDot({
								//     index: 1
								// })
								// this.companyJobList = []
								resolve([])
								localStorage.setItem('job_title', '')
								localStorage.setItem('job_users', 1)
							}
						} else {
							resolve([])
						}
					}, () => {
						resolve([])
					})
				})
			},
			addStaff() {
				this.staffList.push({
					name: '',
					tel: '',
					sex: '男',
					postion: '',
				})
			},

			goUp() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				sessionStorage.setItem('meetObj', JSON.stringify(this.meetData))
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.selectMeetList))

				sessionStorage.setItem('staffList', JSON.stringify(this.staffList))
				this.$router.push({
					path: '/addPosition?isMeet=1',
				})
				// this.formPage = 'upjob'
				// this.$uniapp.goPage('/pages/recruit/upjob')
			},


			openPublishedJobDialog() {
				this.publishedJobDialogVisible = true
				this.publishedJobLoading = true
				this.$util.post('v2/school_job/my_job_list', {
					admin_id: this.schoolInfo.admin_id,
					user_id: this.userInfo.user_id,
					page: 1,
					size: 10000,
					st: '20250201',
					sale_status: 1,
				}, (res) => {
					this.publishedJobLoading = false
					if (res.code != 200) {
						this.$message.error(res.msg || '获取已发布岗位失败')
						return
					}
					this.publishedJobList = res.data && Array.isArray(res.data.data) ? res.data.data : []
					let selectedJobIds = this.companyJobList.map((item) => item.id)
					this.selectedPublishedJobIds = selectedJobIds
					this.$nextTick(() => {
						this.$refs.publishedJobTable.clearSelection()
						this.publishedJobList.forEach((item) => {
							if (selectedJobIds.includes(item.id)) {
								this.$refs.publishedJobTable.toggleRowSelection(item, true)
							}
						})
					})
				}, () => {
					this.publishedJobLoading = false
					// this.$message.error('获取已发布岗位失败')
				})
			},
			handlePublishedJobSelectionChange(rows) {
				this.selectedPublishedJobIds = rows.map((item) => item.id)
			},
			formatJobNum(value) {
				let text = value == null || value === '' ? '1' : String(value)
				let number = text.match(/\d+/)
				return number ? number[0] : text
			},
			confirmPublishedJobSelection() {
				let currentJobIds = this.companyJobList.map((item) => item.id)
				let selectedJobIds = this.selectedPublishedJobIds
				let removedJobIds = currentJobIds.filter((id) => !selectedJobIds.includes(id))
				this.deletId = Array.from(new Set([...this.deletId, ...removedJobIds]))
				this.deletId = this.deletId.filter((id) => !selectedJobIds.includes(id))
				this.companyJobList = this.publishedJobList.filter((item) => selectedJobIds.includes(item.id))
				this.publishedJobDialogVisible = false
			},
			async sureSign(isCollectFee) {
				if (this.isRequest()) return;
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.jobs = this.companyJobList.map((item) => {
					return {
						job_id: item.id,
						job_num: item.job_num || 1,
					}
				})
				console.log(this.jobs)
				if (this.jobs.length == 0) {
					this.$message.error('请先发布岗位')
					return
				}


				let meetstr = ''
				if (this.headIndex === 1 && !this.isSpecial) {
					if (parseInt(this.boothNum) > this.limitBoothNum) {
						this.$message.error('您申请的展位数量超出限制，请重新输入')
						return
					}
					if (this.needStaffInfo) {
						let isInfo = false
						this.staffList = this.staffList.filter((i) => {
							return i.name || i.tel || i.postion
						})
						if (this.staffList.length === 0) {
							this.staffList = [{
								name: '',
								tel: '',
								sex: '男',
								postion: '',
							}, ]
							this.$message.error('请填写参会人员信息')
							return
						}

						this.staffList.forEach((item) => {
							if (item.name || item.tel || item.postion) {
								meetstr += `姓名：${item.name}，性别：${item.sex}，职务：${item.postion}，电话：${item.tel}；`
							}
							if (!item.name || !item.tel) {
								isInfo = true
							}

						})

						if (isInfo) {
							this.$message.error('请完善参会人员信息')
							return
						}
					}

					const regex = /^1[3-9]\d{9}$/;
					let isphone = false
					this.staffList.forEach((item) => {
						if (!regex.test(item.tel)) {
							isphone = true
						}
					})
					if (this.needStaffInfo && isphone) {
						this.$message.error('手机号格式错误!');
						return
					}

				}

				this.meetstr = meetstr
				this.officialSignupSubmitted = false
				if (this.isCorporateApplyPath) {
					this.toSign1()
					return
				}

				if (isCollectFee && this.paymentDialogMeetList.length > 0) {
					this.restorePlatformPaymentProgress()
					if (this.platformPaymentCompleted && this.officialMeetList.length === 0 && this.platformMeetList.length === this.selectMeetList.length) {
						this.toSign1(this.platformOrderNo)
						return
					}
					if (this.officialMeetList.length > 0 && (!this.isMixedPaymentMeeting || this.isFreePlatformWithOfficial)) {
						this.toSign1('', false, true, true)
						return
					}
					this.isMeetListViewOnly = false
					if (this.platformPaymentCompleted) {
						this.paymentStep = 2
					} else {
						this.paymentStep = 1
						this.hasPlatformFeeWhenDialogOpened = this.platformMeetList.length > 0
					}
					this.meetVisible = true


				} else {
					this.toSign1()
				}


			},
			toCost(){
				if (this.isCorporateApplyPath) {
					this.meetVisible = false
					this.toSign1()
					return
				}
				if (this.isRequest(3000)) return
				if (this.officialSignupSubmitting) {
					this.$message.warning('官网缴费场次报名提交中，请稍候')
					return
				}
				if (this.officialSignupSubmitted) {
					this.officialSignupSubmitted = false
					this.meetVisible = false
					this.clearPlatformPaymentProgress()
					this.getCitysList()
					this.dialogVisible = true
					return
				}
				this.jobs = this.companyJobList.map((item) => {
					return {
						job_id: item.id,
						job_num: item.job_num || 1,
					}
				})
				if (this.jobs.length == 0) {
					this.$message.error('请先发布岗位')
					return
				}

				let meetstr = ''
				if (this.headIndex === 1 && !this.isSpecial) {
					if (parseInt(this.boothNum) > this.limitBoothNum) {
						this.$message.error('您申请的展位数量超出限制，请重新输入')
						return
					}
					if (this.needStaffInfo) {
						let isInfo = false
						this.staffList = this.staffList.filter((i) => {
							return i.name || i.tel || i.postion
						})
						if (this.staffList.length === 0) {
							this.staffList = [{
								name: '',
								tel: '',
								sex: '男',
								postion: '',
							}, ]
							this.$message.error('请填写参会人员信息')
							return
						}

						this.staffList.forEach((item) => {
							if (item.name || item.tel || item.postion) {
								meetstr += `姓名：${item.name}，性别：${item.sex}，职务：${item.postion}，电话：${item.tel}，\n`
							}
							if (!item.name || !item.tel) {
								isInfo = true
							}
						})

						if (isInfo) {
							this.$message.error('请完善参会人员信息')
							return
						}
					}

					const regex = /^1[3-9]\d{9}$/;
					let isphone = false
					this.staffList.forEach((item) => {
						if (!regex.test(item.tel)) {
							isphone = true
						}
					})
					if (this.needStaffInfo && isphone) {
						this.$message.error('手机号格式错误!');
						return
					}
				}

				this.meetstr = meetstr
				this.meetVisible=false
				let hasPlatformMeeting = this.selectMeetList.some((item) => Number(item.meeting_status) === 1)
				if (this.paymentStep === 1 && hasPlatformMeeting && this.officialMeetList.length > 0 && Number(this.platformMeetingPrice) === 0 && !this.isFreePlatformWithOfficial) {
					this.toSign1('', true, true)
				} else if (this.isMixedPaymentMeeting && this.paymentStep === 2) {
					this.toSign1(this.platformOrderNo, false, true)
				} else if (this.isMixedPaymentMeeting && Number(this.platformMeetingPrice) > 0) {
					this.payOrder()
				} else if (this.isMixedPaymentMeeting) {
					this.completePlatformPayment()
				} else if (this.platformMeetList.length === 0) {
					this.toSign1('', false, true)
				} else if (Number(this.platformMeetingPrice) > 0) {
					this.payOrder()
				} else {
					this.toSign1('', false, true)
				}
			},
			isRequest(duration = 1000) {
				if (this.request) return true;
				this.request = true;
				setTimeout(() => {
					this.request = false;
				}, duration)
				return false;
			},
			payOrder() {
				if (this.isCorporateApplyPath) {
					this.toSign1()
					return
				}
				console.log(this.userInfo)
				console.log(this.schoolInfo)
				// if (this.isRequest()) return false;
				// schoolInfo
				// 0.01 ||
				let cprice = config.FEE || Number(this.platformMeetingPrice)
				let item = {
					goodsName: '双选会报名',
					goodId: 72,
					price: cprice,
					remark: this.buildPaymentRemark()
				}
				let abj = {
					name: this.schoolInfo.company_name,
					tel: this.userInfo.tel,
					p_name: this.userInfo.username,
					remark: item.remark || ''
				}
				console.log('orderpay')
				let obj = {
					uid: this.userInfo.user_id,
					pname: this.schoolInfo.company_name,
					pmobile: this.userInfo.tel,
					goods_id: item.goodId,
					spec_id: 0,
					order_price: item.price,
					source: 3,
					remark: item.remark || '',
					order_json: JSON.stringify(abj),
					company_id: this.schoolInfo.admin_id
				}
				this.$util.post(
					'v2/orderCampus', {
						...obj
					},
					(res) => {
						if (res.code == 200) {
							if (res) {
								console.log(res)
								let obj = {
									uid: this.userInfo.user_id,
									pay_money: item.price,
									order_id: res.data.order_no,
									order_name: item.goodsName
								}
								this.order_no = res.data.order_no
								this.$util.post(
									`v2/campusPay`, {
										...obj
										// app_type: 10,
										// page_path: 'pages/recruit/jobdetail',
										// id:id
									},
									(res) => {
										console.log(res)
										if (res.code == 200) {
											this.previewDialogVisible = true
											// this.generateQR(res.msg.code_url)
											this.code_url = res.msg.code_url
											this.interval = setInterval(() => {
												this.getCampusOrderInfo(res.msg.out_trade_no)
											}, 1000)
										} else {
											this.$message.error('支付失败！')
										}

									}
								)


							}
						}
					}
				)
			},
			getCampusOrderInfo(out_trade_no) {
				this.$util.get(
					`v2/getCampusOrderInfo`, {
						order_no: out_trade_no,
						uid: this.userInfo.user_id,
					},
					(res) => {
						if (res.code == 200) {
							if (res.data.order_status == 1) {
								clearInterval(this.interval)
								// this.$message({
								// 	message: '支付成功',
								// 	type: 'success',
								// })
								if (this.paymentCloseConfirmVisible) {
									this.paymentCloseConfirmAutoClosed = true
									this.paymentCloseConfirmVisible = false
									this.$msgbox.close()
								}
								this.previewDialogVisible = false
								if (this.isMixedPaymentMeeting) {
									this.toSign1(out_trade_no, true, true)
								} else {
									this.toSign1(out_trade_no, false, true)
								}
								// setTimeout(()=>{
								// 	this.$router.push({
								// 		path: '/reglist',
								// 	})
								// },1000)
							}
						} else {
							clearInterval(this.interval)
							this.previewDialogVisible = false
							this.$message.error('支付失败！')
						}

					}
				)
			},

			toSign1(out_trade_no, continueToOfficialPayment = false, keepMeetVisibleOnError = false, deferSuccessDialog = false) {
				if (this.isCorporateApplyPath) {
					this.isSpecial = true
				}
				let isModifySignup = this.isComplete && !this.isBatch
				let modifyAdvNum = isModifySignup ? this.getMeetingAdvNum(this.selectMeetList[0] || {}) : this.boothNum || 0
				let c_josn = {
					staffs: this.needStaffInfo ? this.staffList : [],
					adv_num: this.boothNum,
					headIndex: this.headIndex,
					deletId: this.deletId,
				}
				let obj = {
					admin_id: this.schoolInfo.admin_id,
					meeting_id: this.meetData.meetId,
					job_data: JSON.stringify(this.jobs),
					meeting_info_str: this.meetstr,
					adv_num: modifyAdvNum,
					ads_need: this.meet_1,
					lecture_need: this.meet_2,
					student_visit_free: this.meet_3,
					sxzx_job_activity_need: this.meet_4,
					student_record_need: this.meet_5,
					job_fair_need: this.meet_6,
					all_in_need: this.meet_7,
					meeting_info: JSON.stringify(c_josn),
                    reg_meet_code:localStorage.getItem('salesmanPhone') || ''
                     // obj.reg_meet_code =  uni.getStorageSync('salesmanPhone') || ''
				}
				if (out_trade_no) {
					obj.order_no = out_trade_no
				}
				let url = isModifySignup ? 'v2/school_job/regSchoolMeeting' : 'v2/school_job/regBatchSchoolMeeting2'
				let meetingList = this.selectMeetList
				if (continueToOfficialPayment) {
					meetingList = this.platformMeetList
				} else if (this.isMixedPaymentMeeting && this.paymentStep === 2) {
					meetingList = this.officialMeetList
				}
				obj.meeting_id_json = JSON.stringify(meetingList.map((item) => {
					let meeting = {
						id: String(item.id),
							price: '0',
						meeting_cate: String(item.meeting_cat),
					}
					if (Number(item.meeting_status) === 1 && this.getFeeValue(item.meeting_price) > 0) {
						meeting.adv_num = this.getMeetingAdvNum(item)
					}
					return meeting
				}))
				if (isModifySignup) {
					obj.paid_meeting_price = this.paidMeetingPrice
				} else {
					delete obj.meeting_id
				}
				sessionStorage.removeItem('staffList')
				if (this.isSpecial) {
					obj.isComplete = this.isComplete
					sessionStorage.setItem('applyData', JSON.stringify(obj))
					this.$router.push({
						path: '/corporateApply',
						// query: {
						//   id: 1,
						// },
					})
					return
				}

				// return 
				if (this.isComplete) {
					let that = this
					this.$confirm('重新报名将会覆盖上次的报名信息，是否确定？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						})
						.then(() => {

							this.$util.post(url, obj, (res) => {
								if (res.code == 200) {
									localStorage.setItem('deleteId', that.deletId)
									if (continueToOfficialPayment) {
										this.completePlatformPayment(out_trade_no)
										return
									}
									if (deferSuccessDialog) {
										this.officialSignupSubmitting = false
										this.officialSignupSubmitted = true
										this.markCompletedOfficialMeetings(meetingList)
										this.meetVisible = true
										return
									}
									if (this.isOnlineMeeting) {
										this.clearPlatformPaymentProgress()
										localStorage.removeItem('addMeetJob')
										this.$router.replace({
											path: '/reglist',
										})
										return
									}
									this.clearPlatformPaymentProgress()
									this.getCitysList()
									this.dialogVisible = true
									// this.$router.push({
									// 	path: '/meeting',
									// })
									localStorage.removeItem('addMeetJob')
								} else {
									if (deferSuccessDialog) this.officialSignupSubmitting = false
									if (keepMeetVisibleOnError) this.meetVisible = true
									this.$message.error(res.msg)
								}
							})

						})
						.catch(() => {})
					return
				}

				this.$util.post(url, obj, (res) => {
					if (res.code === 200) {
						// this.$message.success('报名成功')
						localStorage.setItem('deleteId', this.deletId)
						if (continueToOfficialPayment) {
							this.completePlatformPayment(out_trade_no)
							return
						}
					if (deferSuccessDialog) {
						this.officialSignupSubmitting = false
						this.officialSignupSubmitted = true
						this.markCompletedOfficialMeetings(meetingList)
						this.meetVisible = true
						return
					}
					if (this.isOnlineMeeting) {
						this.clearPlatformPaymentProgress()
						this.$router.replace({
							path: '/reglist',
						})
						return
					}
					this.clearPlatformPaymentProgress()
						this.getCitysList()
						this.dialogVisible = true
						// this.$router.push({
						// 	path: '/meeting',
						// })
						// uni.redirectTo({
						//   url: '/pages/service/registration',
						// })
					} else {
						if (deferSuccessDialog) this.officialSignupSubmitting = false
						if (keepMeetVisibleOnError) this.meetVisible = true
						this.$message.error(res.msg)
					}
				})
			},
			getRegMeetingDetail() {
				return new Promise((resolve, reject) => {
					let obj = {
						admin_id: this.schoolInfo.admin_id,
						// meeting_id: this.meetData.meetId || 2018,
					}
					// v2/school_job/getRegMeetingDetail
					this.$util.post('v2/school_job/getRegMeetingDetailNew', obj, (res) => {
						if (res.data) {
							this.meet_1 = res.data.ads_need || ''
							this.meet_2 = res.data.lecture_need || ''
							this.meet_3 = res.data.student_visit_free || ''
							this.meet_4 = res.data.sxzx_job_activity_need || ''
							this.meet_5 = res.data.student_record_need || ''
							this.meet_6 = res.data.job_fair_need || ''
							this.meet_7 = res.data.all_in_need || ''
							if (res.data.meeting_info) {
								let meeting_infos = JSON.parse(res.data.meeting_info)
								this.headIndex = meeting_infos.headIndex
								if (meeting_infos.adv_num) {
									this.boothNum = parseInt(meeting_infos.adv_num)
								} else {
									this.boothNum = ''
								}
								if (Array.isArray(meeting_infos.staffs) && meeting_infos.staffs.length > 0) {
									this.staffList = meeting_infos.staffs
									this.hasStaffListFromApi = true
								}
								// this.deletId = meeting_infos.deletId
								localStorage.setItem('deleteId', this.deletId)
							}
							if (res.data.job_data) {
								resolve(res.data.job_data)
							} else {
								resolve([])
							}
							// if (res.data.job_data) {
							//     let c_job_data = JSON.parse(res.data.job_data)
							//     this.jobDataIds = c_job_data.map(item => {
							//         return item.job_id
							//     })

							// }


						} else {
							resolve([])
						}
					}, () => {
						resolve([])
					})
				})
			},


			getRegMeetingDetail1() {
				return new Promise((resolve, reject) => {
					let obj = {
						admin_id: this.schoolInfo.admin_id,
						meeting_id: this.meetData.meetId || 2018,
					}
					// v2/school_job/getRegMeetingDetail
					this.$util.post('v2/school_job/getRegMeetingDetail', obj, (res) => {
						if (res.data) {
							this.paidMeetingPrice = res.data.paid_meeting_price
							this.meet_1 = res.data.ads_need || ''
							this.meet_2 = res.data.lecture_need || ''
							this.meet_3 = res.data.student_visit_free || ''
							this.meet_4 = res.data.sxzx_job_activity_need || ''
							this.meet_5 = res.data.student_record_need || ''
							this.meet_6 = res.data.job_fair_need || ''
							this.meet_7 = res.data.all_in_need || ''
							if (res.data.meeting_info) {
								let meeting_infos = JSON.parse(res.data.meeting_info)
								this.headIndex = meeting_infos.headIndex
								if (meeting_infos.adv_num) {
									this.boothNum = parseInt(meeting_infos.adv_num)
								} else {
									this.boothNum = ''
								}
								if (Array.isArray(meeting_infos.staffs) && meeting_infos.staffs.length > 0) {
									this.staffList = meeting_infos.staffs
									this.hasStaffListFromApi = true
								}
								this.isComplete = true
								this.deletId = meeting_infos.deletId
								localStorage.setItem('deleteId', this.deletId)
							}
							if (res.data.job_data) {
								resolve(res.data.job_data)
							} else {
								resolve([])
							}
							// if (res.data.job_data) {
							//     let c_job_data = JSON.parse(res.data.job_data)
							//     this.jobDataIds = c_job_data.map(item => {
							//         return item.job_id
							//     })

							// }

							this.audit_status = res.data.audit_status
						} else {
							resolve([])
						}
					}, () => {
						resolve([])
					})
				})
			},

			getmyJobList() {
				this.loading = true

				this.$util.post(
					'v2/school_job/my_job_list', {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
						page: this.currentpage,
						size: 6,
                        sale_status: 1,
						...this.searchObj,
					},
					(res) => {
						if (res.code == 200) {
							this.jobList = res.data.data
							this.total = res.data.meta.total
						}
						this.loading = false
					}, (err) => {
						console.log(err)
						this.loading = false
					}
				)
			},
			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
				switch (status) {
					case 0:
						return Y + M + D
					case 1:
						return Y + M + D + H + Minu + S
					default:
						break
				}
			},
			seeMoreJob() {
				if (this.jobNum === 3) {
					this.jobNum = 100
				} else {
					this.jobNum = 3
				}
			},
			selectsex(val, item) {
				item.sex = val
				console.log('2222', val)
			},
			async saveForm() {
				if (this.isRequest()) return;
				console.log(this.invoice_type)
				if (this.card_title.trim() == '') {
					this.$message.error('请输入发票抬头名称');
					return
				}
				if (this.card_number.trim() == '') {
					this.$message.error('请输入纳税人识别号');
					return
				}
				if (this.invoice_type == 1) {
					if (this.card_address.trim() == '') {
						this.$message.error('请输入单位地址');
						return
					}
					if (this.card_tel.trim() == '') {
						this.$message.error('请输入单位电话');
						return
					}
					if (this.card_bank.trim() == '') {
						this.$message.error('请输入单位开户银行');
						return
					}
					if (this.card_bank_num.trim() == '') {
						this.$message.error('请输入单位开户银行账号');
						return
					}
				}
				let card_mail = this.card_mail.trim()
				const regex = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i
				if (!regex.test(card_mail)) {
					this.$message.error('请输入正确格式的邮箱')
					return
				}

				this.$confirm(`请仔细核对开票信息，开票成功后，发票将发送到您的邮箱。`, '确认开票', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: true,
						type: 'warning',
					})
					.then(() => {
						let obj = {
							admin_id: this.schoolInfo.admin_id,
							order_no: this.order_no,
							invoice_type: this.invoice_type == 0 ? '数字化电子普票（电子）' : '数字化电子专票（电子）',
							unit_name: this.card_title,
							tax_no: this.card_number,
							unit_addr: this.card_address,
							telephone: this.card_tel,
							deposit_bank: this.card_bank,
							bank_account: this.card_bank_num,
							// 0.01 || 
							order_amount: config.FEE || this.totalMeetingPrice,
							email: card_mail,
							invoice_status: 1
							// meeting_id:this.meetId || 0
						}
						this.$util.post(
							`v2/school_job/invoice`, {
								...obj
							},
							(res) => {
								if (res.code == 200) {
									this.$message({
										type: 'success',
										message: '发票提交成功',
									})
									this.invoice = false
									this.isinvoice = false
								} else {
									this.$message({
										type: 'error',
										message: '发票提交失败',
									})
								}
								this.invoice1(obj)
							}
						)

					})
					.catch((err) => {
						console.log(err)
						// this.$message({
						// 	type: 'info',
						// 	message: '已取消',
						// })
					})
			},
			invoice1(obj) {
				this.$util.post(
					`v2/school_job/SaveInvoiceInfo`, {
						...obj
					},
					(res) => {


					}
				)
			},
			getCitysList() {
				// `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/dgsgbkjfkmzswgvs.json?${Math.random()}`
				this.$util.get1(
					`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/dgsgbkjfkmzswgvs.json?${Math.random()}`, {},
					(res) => {
						console.log(this.meetData.meetId)
						if (res['mid_' + this.meetData.meetId]) {
							this.qrcodeImg = res['mid_' + this.meetData.meetId]
						} else {
							let province = ''
							console.log(this.schoolInfo.company_name)
							console.log(res)
							res.provinces.forEach(item => {
								item.citys.forEach(i => {
									if (this.schoolInfo.company_name.indexOf(i.cityName) > -1 || this
										.schoolInfo.company_name.indexOf(item.provinceName) > -1) {
										province = item.provinceName
									}
								})
							})

							this.provinceImgList = res.qrcodeImgs
							if (this.provinceImgList[province]) {
								this.qrcodeImg = this.provinceImgList[province]
							} else {
								this.qrcodeImg =
									'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/wv4br98vawxpxkei.png'
							}
						}



					}
				)
			},
		},
		components: {
			QrcodeVue
		},
	}
</script>
<style>
	.published-job-dialog .published-job-selection-header .cell,
	.published-job-dialog .published-job-selection-cell .cell {
		padding-left: 0;
		padding-right: 0;
	}

	.payment-close-confirm__icon {
		width: 18px;
		height: 16px;
		background: url('https://oss.sx985.com/2023/03/24/sanjiaoxing1.png') center / 18px 16px no-repeat;
	}

	.confirmButtonClass {
		background: #fff !important;
		color: #606266 !important;
		border: 1px solid #dcdfe6 !important;
	}

	.cost .is-checked .el-checkbox__inner {
		background-color: #29c734 !important;
		border-color: #29c734 !important;
	}

	.cancelButtonClass {
		color: #fff !important;
		background-color: #1e40af !important;
		border-color: #1e40af !important;
	}

	#signup .preview .el-dialog {
		background: initial !important;
		box-shadow: initial !important;
	}


	#signup .meetList .el-table .cell {
		text-align: center !important;
	}

	#signup .meetList .el-table__header th {
		background: #e9eeff;
		font-weight: bold !important;
		color: #2a2929 !important;
	}

	#signup .meetList .el-table__body td {
		background: #f9fbff;
	}

	#signup .meetList .el-table::before {
		height: 0;
	}

	#signup .meetList .el-dialog__body {
		padding: 0 20px 30px 20px !important;
		/* 表格自身负责纵向滚动，避免弹窗与表格同时出现滚动条。 */
		overflow-y: hidden;
	}

	#signup .meetList .el-table__body-wrapper,
	#signup .cost .el-dialog__body > .costContainer > div:first-child {
		scrollbar-width: thin;
		scrollbar-color: #b8c3d6 transparent;
	}

	#signup .meetList .el-table__body-wrapper::-webkit-scrollbar,
	#signup .cost .el-dialog__body > .costContainer > div:first-child::-webkit-scrollbar {
		width: 6px;
	}

	#signup .meetList .el-table__body-wrapper::-webkit-scrollbar-track,
	#signup .cost .el-dialog__body > .costContainer > div:first-child::-webkit-scrollbar-track {
		background: transparent;
	}

	#signup .meetList .el-table__body-wrapper::-webkit-scrollbar-thumb,
	#signup .cost .el-dialog__body > .costContainer > div:first-child::-webkit-scrollbar-thumb {
		background: #b8c3d6;
		border-radius: 3px;
	}

	#signup .meetList .el-table__body-wrapper::-webkit-scrollbar-thumb:hover,
	#signup .cost .el-dialog__body > .costContainer > div:first-child::-webkit-scrollbar-thumb:hover {
		background: #8fa1bd;
	}

	#signup .cost .el-dialog__body > .costContainer > div:first-child {
		/* 覆盖历史内联样式：内容溢出时才展示滚动条。 */
		overflow-y: auto !important;
	}

	#signup .meetList .el-dialog__body,
	#signup .cost .el-dialog__body {
		padding: 0 16px 28px !important;
	}

	#signup .meetList .el-dialog__title {
		position: relative;
		display: inline-block;
		padding-left: 10px;
		font-size: 18px !important;
	}

	#signup .meetList .el-dialog__title::before {
		position: absolute;
		left: 0;
		top: 3px;
		width: 4px;
		height: 17px;
		border-radius: 2px;
		background: #1472ff;
		content: '';
	}

	#signup .meetList .el-dialog__wrapper {
		display: flex;
		align-items: center;
	}

	#signup .meetList .el-dialog {
		margin: 0 auto !important;
		max-height: 80vh;
		display: flex;
		flex-direction: column;
	}

	#signup .cost .single-cost-dialog.el-dialog__wrapper {
		display: flex;
		align-items: center;
	}

	#signup .cost .single-cost-dialog.el-dialog {
		margin: 0 auto !important;
		max-height: 80vh;
		display: flex;
		flex-direction: column;
		border-radius: 2px;
	}

	#signup .cost .single-cost-dialog .el-dialog__header {
		position: relative;
		padding: 22px 56px 16px 28px;
	}

	#signup .cost .single-cost-dialog .el-dialog__title {
		position: relative;
		display: inline-flex;
		align-items: center;
		font-size: 18px;
		font-weight: 700;
		line-height: 25px;
		color: #000000;
	}

	#signup .cost .single-cost-dialog .el-dialog__title::before {
		content: '';
		display: inline-block;
		width: 4px;
		height: 17px;
		margin-right: 7px;
		background: #1E68FF;
		border-radius: 2px;
	}

	#signup .cost .single-cost-dialog .el-dialog__headerbtn {
		top: 24px;
		right: 28px;
		font-size: 24px;
	}

	#signup .cost .single-cost-dialog .el-dialog__headerbtn .el-dialog__close {
		color: #000000;
		font-weight: 500;
	}

	#signup .cost .single-cost-dialog .el-dialog__body {
		min-height: 0;
		overflow-y: auto;
		padding: 10px 16px 28px;
	}

	#signup .preview .el-dialog {
		transform: scale(.8);
	}

</style>
<style lang="less" scoped>
	.new-head-bar {
		overflow: hidden;
		width: 710px;
		height: 110px;
		position: relative;
		border-radius: 10px;
		padding: 0 20px;
		box-sizing: border-box;

		.right {
			position: absolute;
			width: 250px;
			height: 80px;
			right: 0;
			bottom: 0;
			// background: red;
		}

		.left {
			position: absolute;
			width: 500px;
			height: 80px;
			left: 0;
			bottom: 0;
			// background: red;
		}

		.h-title {
			font-weight: 600;
			font-size: 22px;
			color: #fefefe;
			line-height: 60px;
		}

		.h1 {
			align-items: center;
			justify-content: flex-start;

			img {
				width: 16px;
				height: 16px;
				margin-right: 5px;
			}

			span {
				font-size: 14px;
				color: #f6f7fb;
				line-height: 24px;
			}
		}
	}



	.content-item {
		width: 710px;
		height: auto;
		background: #f7f8fc;
		border-radius: 10px;
		margin-top: 15px;
		padding: 16px 30px 20px 20px;
		box-sizing: border-box;

		.title-1 {
			.t1 {
				font-weight: bold;
				font-size: 18px;
				color: #000000;
			}

			.t2 {
				font-weight: 400;
				font-size: 14px;
				color: #807f7f;
			}

			image {
				width: 30px;
				height: 30px;
				margin-left: 4px;
			}

			.t2-btn {
				width: 134px;
				height: 54px;
				text-align: center;
				background: #059e6e;
				border-radius: 27px;
				line-height: 54px;
				font-size: 26px;
				color: #ffffff;
			}
		}

		.title-2 {
			// height: 40px;
			margin-top: 20px;
			padding: 5px 20px;
			box-sizing: border-box;

			span {
				font-size: 18px;
				color: #000000;
			}

			.right {
				width: 60px;
				text-align: right;
			}

			image {
				width: 30px;
				height: 30px;
				display: div;
				margin-left: 30px;
			}
		}

		.title-8 {
			margin-top: 20px;
			justify-content: space-between;

			.left,
			.right {
				width: 316px;
				height: 66px;
				background: #f7f8fc;
				border-radius: 33px;
				padding-left: 30px;
				box-sizing: border-box;
				line-height: 66px;

				.i1 {
					width: 30px;
					height: 30px;
					vertical-align: middle;
				}

				.t1 {
					font-size: 18px;
					color: #424141;
					margin-left: 14px;
					vertical-align: middle;
				}

				.t3 {
					font-size: 14px;
					color: #999999;
					// margin-left: 6px;
					vertical-align: middle;
				}

				.i2 {
					width: 20px;
					height: 20px;
					vertical-align: middle;
					margin-left: 10px;
					margin-right: 10px;
				}
			}

			.left {
				width: 400px;
			}

			.right {
				width: 232px;
			}
		}

		.title-3 {
			width: 750px;
			height: 66px;
			background: #f7f8fc;
			border-radius: 33px;
			padding: 0 30px 0 30px;
			box-sizing: border-box;
			margin-top: 18px;

			.t1 {
				// font-size:18px;
				// color: #807F7F;
				font-size: 18px;
				color: #1b1b1b;
				height: 66px;
			}

			.t2 {
				width: 134px;
				height: 54px;
				text-align: center;
				background: #059e6e;
				border-radius: 27px;
				line-height: 54px;
				font-size: 26px;
				color: #ffffff;
			}

			.v-img {
				width: 50px;
				height: 66px;
				overflow: hidden;

				image {
					width: 30px;
					height: 30px;
					opacity: 0.6;
					display: div;
					margin-top: 18px;
					margin-left: 20px;
				}
			}
		}


		.title-5 {
			width: 100%;
			// height: 298px;
			padding: 10px 0;
			background: #ffffff;
			border-radius: 10px;
			margin-top: 20px;

			.title-item {
				height: 50px;
				padding: 0 18px;
				box-sizing: border-box;

				.left {
					font-size: 18px;
					color: #1b1b1b;
					width: 80px;
				}

				input {
					font-size: 18px;
					color: #1b1b1b;
					opacity: 0.7;
					width: 80px;
					height: 50px;
					line-height: 50px;
					border: none;
					outline: none;
					padding-left: 20px;
					box-sizing: border-box;
				}

				img {
					width: 20px;
					height: 20px;
					// opacity: 0.6;
				}
			}
		}

		.title-4 {
			width: 100%;
			height: 60px;
			border-bottom: 1px solid #f2f2f2;

			.right {
				font-size: 18px;
				color: #059e6e;
			}

			image {
				width: 40px;
				height: 40px;
				margin-left: 10px;
			}
		}


	}

	.foot-btn-wrap {
		width: 710px;
		text-align: right;
		padding: 20px 0;
	}

	.foot-btn-box {
		width: 750px;
		height: 144px;
		background: #f6f7fb;
		box-shadow: 0px 6px 38px 2px #9f9f9f;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 10;
		overflow: hidden;

		.foot-btn {
			width: 682px;
			height: 72px;
			background: #059e6e;
			border-radius: 36px;
			margin: 20px auto 0;
			text-align: center;
			line-height: 72px;
			font-weight: bold;
			font-size: 18px;
			color: #f6f7fb;
		}
	}

	.item-job-box {
		margin-top: 20px;

		.item {
			background: #ffffff;
			// border-bottom: 1px solid #f2f2f2;
			padding: 12px 18px;
			margin-top: 12px;
			box-sizing: border-box;
			border-radius: 10px;
		}

		.item-job-more {
			padding-top: 20px;
			// height: 80px;
			// line-height: 80px;
			text-align: left;
			font-size: 14px;
			color: #000000;
			font-weight: 400;
			opacity: 0.8;
			padding-left: 10px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.left {
			overflow: hidden;
			margin-right: 20px;
			cursor: pointer;

			.t1-box {
				.t1 {
					font-size: 18px;
					// font-weight: bold;
					color: #000000;
					line-height: 26px;
					overflow: hidden;
					/* 隐藏溢出的内容 */
					white-space: nowrap;
					/* 文本不换行 */
					text-overflow: ellipsis;
					/* 显示省略号来表示溢出 */
				}

				.t4 {
					font-size: 18px;
					// font-weight: bold;
					color: #ff6600;
					line-height: 26px;
					white-space: nowrap;
				}

				.img1 {
					width: 36px;
					height: 36px;
					margin-left: 10px;
				}

				.img2 {
					width: 34px;
					height: 20px;
					margin-left: 10px;
					// min-width: 50px;
				}
			}

			.t2-box {
				margin-top: 12px;
				overflow: hidden;
				// height: 48px;
			}

			.t2 {
				font-size: 14px;
				color: #000000;
				font-weight: 400;
				line-height: 24px;
				opacity: 0.6;
				background: #ffffff;
				// background: red;
				padding: 0 16px;
				border-radius: 6px;
				display: inline-div;
				border: 1px solid #e5e5e5;
			}

			.t5 {
				font-size: 14px;
				color: #000000;
				font-weight: 400;
				line-height: 36px;
				opacity: 0.6;
			}

			.t3 {
				width: 1px;
				height: 20px;
				background: none;
				display: inline-div;
				margin-left: 6px;
				margin-right: 6px;
			}
		}

		image {
			width: 40px;
			height: 40px;
		}
	}

	.empty_noinfo-box {
		width: 200px;
		height: 200px;
		margin: 0 auto;
		display: div;
	}

	.empty_noinfo-txt {
		font-weight: 400;
		font-size: 18px;
		color: #7f7f7f;
		text-align: center;
		padding-bottom: 30px;
	}



	.title-item-border {
		position: relative;

		&::after {
			position: absolute;
			content: '';
			width: 520px;
			height: 1px;
			background: #f2f2f2;
			bottom: 0;
			left: 110px;
		}
	}

	.titleContainer {
		display: flex;
		align-items: center;
		margin-bottom: 30px;
		margin-top: 20px;

		.shu {
			width: 2px;
			height: 13px;
			background: #1472ff;
			margin-right: 7px;
		}

		.title {
			font-weight: bold;
			font-size: 16px;
			color: #333333;
		}
	}



	#signup .previewDialogVisible .el-dialog {
		background: initial;
		box-shadow: initial;
		margin: 0 auto !important;
	}

	#signup .el-dialog.previewDialogVisible {
		width: 980px !important;
		max-width: calc(100vw - 32px);
		margin: 0 auto !important;
		transform: none !important;
	}

	#signup .previewDialogVisible.el-dialog__wrapper {
		display: flex;
		align-items: center;
	}

	#signup .previewElDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 48px 58px;
			background: #FFFFFF;
			border-radius: 8px;

			.title {
				font-weight: bold;
				font-size: 22px;
				color: #2A2929;
				margin: 0 0 24px;
				padding-left: 12px;
				line-height: 24px;
				border-left: 4px solid #1e40af;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	#signup .qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 52px;

		.qrcode {
			box-sizing: border-box;
			width: 400px;
			padding: 16px 0 0;
			background: #FFFFFF;
			border-radius: 14px;
			border: 4px solid #e9eef2;
			overflow: hidden;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcode__wechat-icon {
				height: 34px;
				font-size: 0;

				img {
					width: 30px;
					height: 30px;
				}
			}

			.qrcode__image {
				margin: 14px 0 24px;
			}

			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}

			.qrcode__payment-tip {
				margin-bottom: 22px;
			}

			.qrcode__amount {
				font-weight: bold;
				font-size: 24px;
				color: #00c800;
			}

			.qrcode__warning-tip {
				box-sizing: border-box;
				width: 100%;
				min-height: 76px;
				padding: 14px 14px 13px;
				background: #fff7e6;
				color: #606266;
				font-size: 16px;
				line-height: 26px;
				display: flex;
				align-items: flex-start;
				text-align: left;

				i {
					margin: 4px 8px 0 0;
					color: #ff9800;
					font-size: 18px;
					flex: none;
				}
			}
		}
	}

	#signup .qrcodeContainer .offline-payment {
		position: relative;
		box-sizing: border-box;
		    width: 430px;
		    padding-left: 16px;
		
	}

	#signup .qrcodeContainer .offline-payment::before {
		position: absolute;
    
		left: -20px;
		top: 0;
		bottom: 0;
		border-left: 1px dashed #d9d9d9;
        
        width:1px;
		content: '';
        transform: scaleY(0.9);
	}

	#signup .offline-payment__title {
		margin: -48px 0 28px 0;
		padding-left: 12px;
		border-left: 4px solid #1e40af;
		font-size: 22px;
		font-weight: bold;
		line-height: 24px;
		color: #2a2929;
	}

	#signup .offline-payment__card {
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		height: 430px;
		overflow: hidden;
		border: 4px solid #e9eef2;
		border-radius: 14px;
		background: #ffffff;
		font-size: 16px;
		color: #222222;
        transform: translateY(-4px);
	}

	#signup .offline-payment__step { padding: 16px; font-size: 16px; line-height: 22px;background: #eef3ff; }
	#signup .offline-payment__account { padding: 10px 16px 24px; }
	#signup .offline-payment__account > div { display: flex; align-items: center; margin-top: 12px; white-space: nowrap; }
	#signup .offline-payment__account span { flex: none; }
	#signup .offline-payment__account strong { box-sizing: border-box; flex: 1; padding: 4px 12px; border-radius: 16px; background: #eef3ff; font-size: 14px; font-weight: 400; line-height: 16px; }
	#signup .offline-payment__service { flex: 1; padding-bottom: 16px; background: #eef3ff; text-align: center; font-size: 14px; line-height: 20px; }
	#signup .offline-payment__service .offline-payment__step { padding: 14px 16px 12px; text-align: left; }
	#signup .offline-payment__service-qrcode { width: 96px; height: 96px; margin: 0 auto 8px; background: #ffffff url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/02/21/wv4br98vawxpxkei.png') center / contain no-repeat; }



	#signup .preview .elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 20px 50px 20px;
			background: #ffffff;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}





	#signup .changePassword {
		.elDialogContainer {

			.ipt {
				width: 100%;
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				border: 1px solid #DCDFE6;
				border-radius: 4px;
				padding: 0 15px;

				.text {
					// width: 135px;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: 16px;
					color: #343232;
				}

				.el-input {
					flex: 1 !important;
				}

				.el-select {
					flex: 1 !important;
				}

				.el-textarea {
					flex: 1 !important;
				}

				.invoice-edit-icon {
					width: 16px;
					height: 16px;
					margin-top: 12px;
				}
			}
		}
	}






	#signup .changePassword {
		display: flex;
		align-items: center;

		.uploadText {
			width: 310px;
			font-weight: 500;
			font-size: 14px;
			color: #999999;
		}
	}




	#signup .meetList {

	}

	.foot-btn {
		width: 100%;
		height: 72px;
		background: #059E6E;
		border-radius: 36px;
		margin: 20px auto 0;
		text-align: center;
		line-height: 72px;
		font-weight: bold;
		font-size: 18px;
		color: #F6F7FB;
	}

	.cost {
		

		.costContainer {

			.item {
				margin-top: 20px;

			
				.costContainer {
					background: #f5fbfe;
					border-radius: 10px;
					padding:0 10px;
					margin-top: 10px;

					

				}
			}

			.total {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 30px;
				padding: 0 22px 0 34px;

				.left {
					font-size: 18px;
					font-weight: bold;
					line-height: 25px;
					color: #000000;
				}

				.right {
					font-size: 20px;
					font-weight: 600;
					line-height: 28px;
					margin-left: 10px;
					color: #f74d00;
				}
			}

		
		}

		.invoice-tip {
			display: flex;
			align-items: center;
			margin-bottom: 20px;
			font-size: 14px;
			color: #909399;

			i {
				margin-right: 6px;
				font-size: 16px;
			}
		}
	}

	#signup .meeting-dialog {
		margin: 0 auto !important;
	}

	#signup .meeting-dialog .el-dialog__header {
		padding: 20px 20px 14px;
		border-bottom: 1px solid #eef0f5;
	}

	#signup .meeting-dialog .el-dialog__title {
		position: relative;
		padding-left: 10px;
		font-size: 18px;
		font-weight: 700;
		color: #1f1f1f;
	}

	#signup .meeting-dialog .el-dialog__title::before {
		position: absolute;
		left: 0;
		top: 3px;
		width: 4px;
		height: 17px;
		background: #1472ff;
		border-radius: 2px;
		content: '';
	}

	#signup .meeting-dialog .el-dialog__headerbtn {
		top: 21px;
		right: 20px;
	}

	#signup .meeting-dialog .el-dialog__headerbtn .el-dialog__close {
		font-size: 20px;
		color: #999999;
	}

	#signup .meeting-dialog__selected {
		padding: 12px 14px;
		background: #e9eeff;
		font-size: 16px;
		font-weight: 700;
		color: #1f1f1f;
	}

	#signup .meeting-dialog__steps {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 16px 14px 10px;
		font-size: 16px;
		font-weight: 700;
		color: #222222;
	}

	#signup .meeting-dialog__step {
		display: flex;
		align-items: center;
		white-space: nowrap;
	}

	#signup .meeting-dialog__step span {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 22px;
		height: 22px;
		margin-right: 10px;
		border-radius: 50%;
		background: #b7b7b7;
		color: #ffffff;
	}

	#signup .meeting-dialog__step-label {
		display: flex;
		align-items: center;
	}

	#signup .meeting-dialog__step-success {
		margin-left: 4px;
		font-size: 12px;
		font-weight: 400;
		color: #ff6600;
	}

	#signup .meeting-dialog__step.is-active span {
		background: #1472ff;
	}

	#signup .meeting-dialog__step.is-complete span {
		background: #b7b7b7;
	}

	#signup .meeting-dialog__step.is-complete .meeting-dialog__step-label {
		color: #b7b7b7;
	}

	#signup .meeting-dialog__step-line {
		width: 88px;
		height: 1px;
		margin: 0 16px;
		background: #d8d8d8;
	}

	#signup .meeting-dialog__list {
		max-height: 390px;
		overflow-y: auto;
	}

	#signup .meeting-dialog__item {
		display: flex;
		align-items: center;
		min-height: 96px;
		padding: 12px 10px;
		border-bottom: 1px solid #e8ebf0;
		box-sizing: border-box;
	}

	#signup .meeting-dialog__cover {
		position: relative;
		width: 108px;
		height: 72px;
		overflow: hidden;
		flex-shrink: 0;
	}

	#signup .meeting-dialog__cover img {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	#signup .meeting-dialog__cover-copy {
		position: relative;
		z-index: 1;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		height: 100%;
		padding: 4px 0 7px;
		font-family: Arial, "Microsoft YaHei", "PingFang SC", sans-serif;
		font-weight: 700;
		text-align: center;
	}

	#signup .meeting-dialog__cover-season {
		font-size: 12px;
		font-weight: 900;
		line-height: 18px;
	}

	#signup [class^="meeting-dialog__cover-name--"] {
		display: block;
		margin-top: 1px;
		overflow: hidden;
		font-weight: 700;
		white-space: nowrap;
	}

	#signup .meeting-dialog__cover-name--large { font-size: 14px; line-height: 16px; }
	#signup .meeting-dialog__cover-name--medium { font-size: 12px; line-height: 14px; }
	#signup .meeting-dialog__cover-name--small { font-size: 10px; line-height: 10px; }
	#signup .meeting-dialog__cover-name--two-line { font-size: 10px; line-height: 13px; white-space: nowrap; }

	#signup .meeting-dialog__info {
		min-width: 0;
		flex: 1;
		padding-left: 10px;
	}

	#signup .meeting-dialog__name {
		overflow: hidden;
		font-size: 16px;
		font-weight: 700;
		line-height: 22px;
		color: #222222;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	#signup .meeting-dialog__time {
		margin-top: 6px;
		font-size: 15px;
		line-height: 20px;
		color: #555555;
	}

	#signup .meeting-dialog__platform-signed {
		margin-top: 2px;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		color: #5b86e5;
	}

	#signup .meeting-dialog__fee {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-top: 5px;
		font-size: 15px;
		font-weight: 700;
		line-height: 20px;
		color: #2d967f;
	}

	#signup .meeting-dialog__adv-num {
		display: inline-flex;
		height: 32px;
		border: 1px solid #2d967f;
		border-radius: 3px;
		overflow: hidden;
		background: #ffffff;
	}

	#signup .meeting-dialog__adv-num button {
		width: 40px;
		padding: 0;
		border: 0;
		background: #ffffff;
		color: #2d967f;
		font-size: 20px;
		line-height: 30px;
		cursor: pointer;
	}

	#signup .meeting-dialog__adv-num button:first-child {
		border-right: 1px solid #2d967f;
	}

	#signup .meeting-dialog__adv-num button:last-child {
		border-left: 1px solid #2d967f;
	}

	#signup .meeting-dialog__adv-num button:disabled {
		color: #c0c4cc;
		cursor: not-allowed;
	}

	#signup .meeting-dialog__adv-num input {
		width: 58px;
		padding: 0 4px;
		border: 0;
		outline: 0;
		color: #606266;
		font-size: 14px;
		text-align: center;
	}

	#signup .meeting-dialog__adv-num input::-webkit-inner-spin-button,
	#signup .meeting-dialog__adv-num input::-webkit-outer-spin-button {
		margin: 0;
		-webkit-appearance: none;
	}

	#signup .meeting-dialog__adv-num-title {
		font: inherit;
		color: inherit;
		white-space: nowrap;
	}

	#signup .meeting-dialog__fee-value {
		flex: 0 0 100px;
		white-space: nowrap;
	}

	#signup .meeting-dialog__remove {
		width: 21px;
		height: 20px;
		margin-left: 14px;
		padding: 0;
		border: 0;
		background: transparent;
		cursor: pointer;
		flex-shrink: 0;
	}

	#signup .meeting-dialog__remove img {
		display: block;
		width: 100%;
		height: 100%;
	}

	#signup .meeting-dialog__registered {
		margin-left: 14px;
		font-size: 14px;
		color: #999999;
		white-space: nowrap;
	}

	#signup .meeting-dialog__website-pay {
		margin-left: 12px;
		padding: 7px 10px;
		border-color: #ff8a5c;
		color: #ff5a1f;
		background: #fff7f3;
	}

	#signup .meeting-dialog__text-remove {
		margin-left: 12px;
		padding: 0;
		border: 0;
		background: transparent;
		color: #666666;
		font-size: 14px;
		cursor: pointer;
	}

	#signup .meeting-dialog__total {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 24px 14px 6px;
		font-size: 18px;
		font-weight: 700;
		color: #222222;
	}

	#signup .meeting-dialog__total strong {
		font-size: 20px;
		font-weight: 500;
		color: #ff4d00;
	}

	#signup .meeting-dialog__actions {
		display: flex;
		justify-content: flex-end;
		margin-top: 26px;
	}

	#signup .meeting-dialog__actions .el-button {
		width: 106px;
		height: 36px;
		padding: 0;
		font-size: 16px;
	}

	#signup .meeting-dialog__actions .el-button--primary {
		margin-left: 10px;
		border-color: #ff6600;
		background: #ff6600;
	}

	#signup .meeting-dialog__official-tip {
		display: flex;
		align-items: flex-start;
		order: 1;
		width: 100%;
		margin-top: 14px;
		font-size: 14px;
		line-height: 22px;
		color: #666666;
	}

	#signup .meeting-dialog__official-tip i {
		margin: 5px 4px 0 0;
		font-size: 14px;
		color: #666666;
	}

	#signup .meeting-dialog__official-tip-confirm {
		color: #ff6600;
	}

	#signup .meeting-dialog__content--with-total {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}

	#signup .meeting-dialog__content--with-total > .meeting-dialog__steps,
	#signup .meeting-dialog__content--with-total > .meeting-dialog__selected,
	#signup .meeting-dialog__content--with-total > .meeting-dialog__list {
		width: 100%;
	}

	#signup .meeting-dialog__content--with-total .meeting-dialog__total {
		flex: 1;
		justify-content: flex-start;
		gap: 12px;
		padding: 22px 8px 0;
	}

	#signup .meeting-dialog__content--with-total .meeting-dialog__selected-count {
		font-size: 16px;
		font-weight: 700;
	}

	#signup .meeting-dialog__content--with-total .meeting-dialog__footer-selected-count {
		order: 2;
		flex: 1;
		padding: 22px 8px 0;
		font-size: 16px;
		font-weight: 700;
        color:#222;
	}

	#signup .meeting-dialog__content--with-total .meeting-dialog__actions {
		order: 3;
		margin-top: 22px;
	}

	@media screen and (max-height: 700px) {
		#signup .meetList .el-dialog.meeting-dialog {
			max-height: calc(100vh - 24px);
		}

		#signup .meetList .el-dialog.meeting-dialog .el-dialog__body {
			flex: 1;
			min-height: 0;
			overflow-y: auto;
		}

		#signup .meeting-dialog__list {
			max-height: calc(100vh - 290px);
		}
	}
</style>
